<template>
  <div ref="root" class="ly-root">
    <LayerBar :s="barState" :nav="nav" @act="onAct">
      <template v-if="$slots.crumbs" #crumbs><slot name="crumbs"/></template>
    </LayerBar>

    <!-- словосочетания столбца: чипы, дорожки или состав среза -->
    <div v-if="phMode !== 'off' && phStats.list.length" class="ly-phbar" @mousemove="onTip" @mouseleave="onTip(null)">
      <span class="ly-plab">{{ phMode === 'lanes' ? 'дорожки:' : phMode === 'mix' ? 'состав среза:' : 'словосочетания:' }}</span>
      <div v-if="phMode === 'mix'" class="ly-phmix">
        <div class="ly-phstack">
          <i v-for="x in phStats.list" :key="x.ph" :data-tip="x.ph + '\n' + x.val + ' из ' + phStats.tot"
             :style="{ width: (x.val / (phStats.tot || 1) * 100).toFixed(2) + '%', background: phColor(x.ph) }"></i>
        </div>
        <div v-for="x in phStats.shown" :key="x.ph" class="ly-pr">
          <i :style="{ background: phColor(x.ph) }"></i><b :data-tip="x.ph">{{ x.ph }}</b>
          <s>{{ nSess(x.n) }}</s>
          <em>{{ x.val }} из {{ phStats.tot }} · {{ Math.round(x.val / (phStats.tot || 1) * 100) }} %</em>
        </div>
      </div>
      <template v-else>
        <span v-for="x in phStats.shown" :key="x.ph" class="ly-phchip">
          <i :style="{ background: phColor(x.ph) }"></i><b :data-tip="x.ph">{{ x.ph }}</b>
          <s>· {{ nSess(x.n) }} · {{ x.val }} из {{ phStats.tot }}</s>
          <s v-if="phMode === 'lanes' && x.rank !== null">· {{ laneName(x.rank) }}</s>
        </span>
      </template>
      <!-- у сегмента «вся таблица» фраз сотни: чипы всех не нужны, счёт остатка честнее -->
      <span v-if="phStats.rest" class="ly-plab">и ещё {{ phStats.rest }}</span>
    </div>

    <LayerTimeline
      v-if="tlOn"
      :units="rowAll" :range="range" :chrono="timeLike && !sortOn" :storyBlock="storyBlock" :tlMode="tlMode"
      :nBlocks="nB" :view="tlView" :here="tlHere" :numOf="numOf"
      @scroll-to="onScrollTo" @range="onRange" @tl-mode="tlMode = $event"
    />
    <!-- срез выше считается по матрице, а карточки ниже — выборка -->
    <div v-if="cappedOf" class="ly-capnote" role="status">
      Показаны последние {{ CARD_CAP }} из {{ cappedOf }} сессий — сузьте окно на ленте времени, чтобы увидеть другие
    </div>

    <div ref="stage" class="ly-stage" :style="{ height: stageH + 'px' }"
         @mousedown="onDown" @pointerover="onHoverMed" @pointerleave="medEqGrp = null"
         @mousemove="onTip" @mouseleave="onTip(null)">
      <div ref="cam" class="ly-cam" :class="{ 'ly-noanim': flying, 'ly-side': sideView }"
           :style="{ transformOrigin: (g.colLeft + g.colW / 2) + 'px ' + (g.colTop + g.colH / 2) + 'px' }">
        <!-- ---------- слой 0: срез ---------- -->
        <div ref="slice" class="ly-l3 ly-slice" :class="{ 'ly-half': layerSel !== 'all' && layerSel !== 'slice' }">
          <div class="ly-ring" :style="px({ left: g.colLeft - 7, top: g.colTop - 7, width: g.colW + 14, height: g.colH + 14 })"></div>
          <div class="ly-tag" :style="px({ left: g.colLeft - 7, top: g.colTop - 50 })">СРЕЗ · {{ nSess(sessions.length) }}</div>
          <button v-for="r in rowLabels" :key="'rl' + r.b" type="button" class="ly-rl" :class="{ 'ly-sorted': r.sorted }"
                  :data-shift="labShift" :style="px({ left: g.labelLeft, top: r.top, width: g.labelW, height: r.h })"
                  :title="r.title" @click.stop="cycleSort(r.b)">
            <span>{{ r.name }}</span><i>{{ r.sorted ? (sortDir === 1 ? '↑' : '↓') : '⇅' }}</i>
          </button>
          <!-- порядковая мера отдельной подписью под блоками: номер блока оттока -->
          <button type="button" class="ly-rl ly-rlhit" :class="{ 'ly-sorted': sortHit }" :data-shift="labShift"
                  :style="px({ left: g.labelLeft, top: lastRow.top + lastRow.h + 8, width: g.labelW, height: lastRow.h })"
                  :title="sortHit ? (sortDir === 1 ? 'Сперва те, у кого отток раньше. Ещё клик — наоборот'
                    : 'Сперва те, у кого отток позже. Ещё клик — снять сортировку') : 'Отсортировать сессии по номеру блока оттока'"
                  data-help="мера/блок синей" @click.stop="cycleHit">
            <span>Блок оттока</span><i>{{ sortHit ? (sortDir === 1 ? '↑' : '↓') : '⇅' }}</i>
          </button>
          <div v-for="t in sliceTiles" :key="'st' + t.b" class="ly-t" :class="{ 'ly-act': focusBlock === t.b }"
               :style="{ ...px({ left: g.colLeft, top: t.top, width: g.colW, height: t.h }), background: t.bg, color: t.ink }"
               :data-tip="t.title" @click.stop="pickSlice(t.b)">{{ t.txt }}</div>
          <template v-if="phMode === 'mix'">
            <div v-for="m in mixBars" :key="'mx' + m.b" class="ly-phmix3"
                 :style="px({ left: g.colLeft, top: m.top, width: g.colW, height: 4 })" :data-tip="m.title">
              <i v-for="p in m.parts" :key="p.ph" :style="{ width: p.w + '%', background: phColor(p.ph) }"></i>
            </div>
          </template>
          <!-- окно ленты: рядом со срезом полоска «сумма окна» — какую часть столбца даёт период -->
          <template v-if="range && units.length">
            <div class="ly-date" :style="px({ left: g.colLeft + g.colW + 10, top: g.colTop + g.colH + 8 })">
              <b class="ly-acc">в окне {{ rangeAll.length }}</b>
            </div>
            <div v-for="w in windowTiles" :key="'wn' + w.b" class="ly-t"
                 :style="{ ...px({ left: g.colLeft + g.colW + 10, top: w.top, width: 34, height: w.h }), background: w.bg, color: w.ink, fontSize: '10px' }"
                 :data-tip="w.title">{{ w.n }}</div>
          </template>
        </div>

        <div ref="track" class="ly-track">
          <!-- напольная линейка времени -->
          <div v-if="railOn && sortBlock === null && units.length && !(phMode === 'lanes' && layout.laneW)"
               class="ly-rail" data-sz="0" data-kind="rail"
               :style="px({ left: g.colLeft + g.colW / 2 - 3, top: g.colTop + g.colH + 26, width: 6, height: layout.maxDepth + 120 })">
            <i v-for="(t, ti) in layout.ticks" :key="ti" :class="{ 'ly-big': t.big }" :style="{ top: t.z + 'px' }"></i>
          </div>
          <!-- дорожки фраз: ровно столько, сколько фраз в ряду, а не три -->
          <template v-if="railOn && sortBlock === null && phMode === 'lanes' && units.length && layout.laneW">
            <div v-for="(ph, k) in laneOrder" :key="'ln' + k" class="ly-rail" data-sz="0" data-kind="rail"
                 :style="{ ...px({ left: g.colLeft + k * layout.laneW + g.colW / 2 - 2, top: g.colTop + g.colH + 26, width: 4, height: layout.maxDepth + 120 }),
                           background: 'linear-gradient(to bottom, ' + phColor(ph) + ', transparent)', opacity: .55 }"></div>
          </template>

          <!-- ---------- медиана ---------- -->
          <template v-for="m in medVM" :key="'md' + m.from">
            <div v-if="medAxis === 'v'" class="ly-med3d" :data-sz="m.zMed" data-kind="isllab" data-medinstr="1"
                 :style="px({ left: m.x - 2, top: g.colTop - 24, height: g.colH + 48 })"></div>
            <div v-else-if="m.ribbon" class="ly-medrib" :data-sz="m.ribbon.sz" data-kind="isl" data-medinstr="1"
                 :style="px({ left: m.x - 3, top: m.ribbon.y, height: m.ribbon.h })"></div>
            <template v-if="m.nEq > 0 && medAxis === 'v'">
              <div class="ly-medeq" :class="{ 'ly-on': medEqGrp === m.from }" :data-sz="m.zEq" data-kind="isllab" data-medinstr="1"
                   :style="px({ left: m.x - 2, top: g.colTop - 24, height: g.colH + 48 })"></div>
              <div class="ly-medeqlab" :class="{ 'ly-on': medEqGrp === m.from }" :data-sz="(m.zEq + m.zMed) / 2"
                   data-kind="isllab" data-medinstr="1" data-lab :style="px({ left: m.x + 14, top: g.colTop - 78 })">
                <b></b>{{ m.nEq }}<s>ровно на медиане</s>
              </div>
            </template>
            <div class="ly-medpill" :data-sz="m.zMed" data-kind="isllab" data-medinstr="1" data-lab
                 :data-medgrp="m.from" data-help="медиана/раскол" :title="m.eqTxt"
                 :style="px({ left: m.x + g.colW / 2 + 16, top: g.colTop + g.colH + 14 })">{{ m.pill }}</div>
            <template v-for="s in m.segs" :key="'sg' + s.k">
              <div class="ly-rail ly-medseg" :data-sz="s.sz" data-kind="isl" data-medinstr="1"
                   :style="{ ...px({ left: m.x - 3, top: g.colTop + g.colH + 20, height: s.len }), background: s.c }"></div>
              <div class="ly-medlab" :class="{ 'ly-on': medBand && medBand[0] === s.band[0] && medBand[1] === s.band[1] }"
                   :data-sz="m.zMed" data-kind="isllab" data-medinstr="1" data-lab :data-medgrp="m.from"
                   data-help="медиана/группа" :title="s.n + ' ' + s.t + ' · ' + m.eqTxt"
                   :style="{ ...px({ left: m.x + 14, top: g.colTop + g.colH + 52 + s.tier * 27 }), '--c': s.c }"
                   @click.stop="setMedBand(s.band)">
                <b></b>{{ s.n }}<s>{{ s.t }}</s>
              </div>
            </template>
            <!-- весы: по строке на словосочетание, стоят на медиане над рядом -->
            <template v-for="w in m.scales" :key="'sk' + w.ph">
              <template v-for="a in w.arms" :key="a.cls">
                <div class="ly-skarm" :class="'ly-' + a.cls" :data-sz="a.sz" data-kind="medarm" :data-dir="a.dir"
                     data-medinstr="1" :data-medgrp="m.from" data-help="медиана/весы" :data-help-label="w.ph" :title="w.live"
                     :style="px({ left: m.x, top: w.y - 4, width: a.len })"></div>
                <div class="ly-sknum" :class="'ly-' + a.cls" :data-sz="a.nsz" data-kind="isllab" data-medinstr="1"
                     :data-medgrp="m.from" data-help="медиана/весы" :data-help-label="w.ph" :title="w.live"
                     :style="px({ left: m.x + 4, top: w.y - 7 })">{{ a.n }}</div>
              </template>
              <div class="ly-skpin" :data-sz="m.zMed" data-kind="isllab" data-medinstr="1" :data-medgrp="m.from"
                   data-help="медиана/весы" :data-help-label="w.ph" :title="w.live"
                   :style="{ ...px({ left: m.x, top: w.y }), '--c': phColor(w.ph) }"></div>
            </template>
          </template>

          <!-- ---------- карточки сессий: одна сессия — одна карточка ---------- -->
          <div v-for="c in cardsVM.list" :key="c.key" class="ly-l3 ly-unit" :class="c.cls"
               :data-layer="c.i" :data-sz="c.sz" data-kind="layer" :data-kx="c.kx" :data-ky="0" :data-baseop="c.baseop"
               :style="{ ...px({ left: BX, top: BY, width: BW, height: BH }), transitionDelay: c.delay, transformOrigin: c.origin }">
            <div class="ly-plate" :style="{ ...px({ left: 9, top: 37, width: c.lw, height: g.colH + 26 + (c.wide ? 16 : 0) }), ...c.tint }"></div>
            <div v-if="phMode !== 'off'" class="ly-phedge" :style="{ ...px({ left: 9, top: 36, width: c.lw }), background: c.color }"></div>
            <div v-if="c.phcap" class="ly-phcap" :style="{ ...px({ left: 9, top: -22 }), color: c.color }">{{ c.u.phrase }}</div>
            <div v-if="c.tag" class="ly-tag" :style="px({ left: 9, top: 22 })" :title="c.tagTitle">
              <b v-if="phMode === 'chips'" class="ly-phd" :style="{ background: c.color }"></b>{{ c.tag }}
            </div>
            <div v-for="t in c.tiles" :key="t.b" class="ly-t ly-bin" :class="{ 'ly-on': t.on, 'ly-act': focusBlock === t.b }"
                 :style="{ ...px({ left: 22, top: t.top, width: c.tw, height: t.h }), fontSize: c.wide ? '' : '0' }"
                 :data-tip="t.title" @click.stop="toggleLayer(c.i, t.b)"></div>
            <div v-if="c.medRowY !== null" class="ly-medrow" :style="px({ left: 18, top: c.medRowY, width: c.tw + 8 })"></div>
            <div v-if="c.wide" class="ly-cdate" :style="px({ left: 22, top: g.colTop + g.colH + 3 - BY, width: c.tw })">{{ c.dateLab }}</div>
            <div v-if="c.date" class="ly-date" :style="px({ left: 9 - c.laneDX, top: c.date.top })" :title="c.date.tip">
              <b>{{ c.date.txt }}</b><i v-if="c.date.cnt > 1">{{ c.date.cnt }}</i>
            </div>
            <div v-if="c.gap" class="ly-gap" :class="{ 'ly-long': c.gap.long }" :style="px({ left: 9 - c.laneDX, top: c.gap.top })">{{ c.gap.txt }}</div>
            <div v-if="c.cap" class="ly-cap" :class="{ 'ly-pullcap': !c.isSel }"
                 :style="px({ left: g.colW + 44, top: g.colH / 2 + 22, height: 56 })">
              <span class="ly-ct">{{ c.cap.name }}</span>
              <span class="ly-cs" :style="{ color: c.color, fontWeight: 650 }">{{ c.u.phrase }}</span>
              <span class="ly-cs">{{ c.cap.churn }}</span>
              <span class="ly-cs">{{ c.cap.date }}</span>
            </div>
          </div>

          <!-- заголовки групп фраз: отдельные билборды, чтобы не гаснуть вместе с карточкой -->
          <template v-if="byPhrase">
            <div v-for="gc in groupCaps" :key="'gc' + gc.i" class="ly-grpcap" :data-sz="gc.sz" data-kind="isllab" data-lab
                 :title="gc.ph" :style="{ ...px({ left: g.colLeft - 13 + gc.x, top: g.colTop - 96 }), '--c': phColor(gc.ph) }">
              <b></b>{{ gc.ph }}<s>{{ gc.cards }} {{ plural(gc.cards, CARDS) }} · {{ nSess(gc.cards) }}</s>
            </div>
          </template>
          <!-- островки под линией -->
          <template v-for="is in islandsVM" :key="'is' + is.k">
            <div class="ly-isl" :data-sz="is.sz" data-kind="isl"
                 :style="px({ left: g.colLeft + g.colW / 2 - 3, top: islTop, width: 6, height: is.h })"></div>
            <div v-if="is.lane >= 0" class="ly-isllab" :data-sz="is.lsz" data-kind="isllab" data-lab
                 :style="px({ left: g.colLeft - 13, top: islTop + 14 + is.lane * 20 })">{{ is.txt }}</div>
          </template>

          <LayerFlags
            v-if="storyBlock !== null"
            :geom="geom" :layout="layout" :storyBlock="storyBlock" :mode="flagsMode" :stats="stats"
            :phraseColor="phColor" :phOff="phMode === 'off'" :medSideOf="medSideFn" :selectedIndex="selIndex" :sideView="sideView" :tileW="TW"
            @select-unit="i => toggleLayer(i, storyBlock)"
          />
          <LayerEventMarks
            v-if="inSceneEv"
            :geom="geom" :layout="layout" :events="evShown" :mode="evMode" :selected="evSel"
            :labelOffset="30 + (maxLane + 1) * 54" :jointsOn="zMode === 'time' && sortBlock === null" :numOf="numOf"
            :tileW="TW" :selectedIndex="selIndex" @select-event="selectEvent"
          />
        </div>
      </div>
      <!-- панели разбора живут поверх сцены в экранных координатах -->
      <LayerAnalysis
        v-if="storyBlock !== null"
        :units="units" :layout="layout" :storyBlock="storyBlock" :frontIndex="frontIdx"
        :panels="panels" :stats="stats" :numOf="numOf" :infOn="anInfOn" @inf="anInfOn = $event" @select-unit="i => toggleLayer(i, storyBlock)"
      />
      <!-- Ф6 лежит поверх сцены справа сверху, как панель прототипа внутри обёртки матрицы -->
      <F6Card
        v-if="f6On"
        :units="sessions" :block="focusBlock" :metric="metric" :ses="column.ses || sessions.length"
        :range="range" :label="column.label" :nBlocks="blocks.length" @close="f6On = false"
      />
    </div>

    <LayerEvents
      v-if="evMode !== 'off'" ref="events"
      :events="evShown" :mode="evMode" :selected="evSel" :range="range" :units="chrono"
      @select-event="id => selectEvent(id, true)" @mode="setEvMode"
    />
    <!-- подсказка плиток сцены: одна на всю сцену, текст ставится прямо в DOM без перерисовки -->
    <div ref="tip" class="ly-tip3" hidden><b></b><span></span></div>

    <!-- карточка сбоку: выбранная сессия или «из чего сложено» число среза -->
    <div v-if="selUnit" class="detail ly-detail" aria-live="polite">
      <div class="ly-dph" :style="{ color: phColor(selUnit.u.phrase) }">
        <b class="ly-phd" :style="{ background: phColor(selUnit.u.phrase) }"></b>{{ selUnit.u.phrase }}
      </div>
      <div class="dhead">
        <span class="big">{{ selUnit.name }}</span>
        <span class="delta">{{ selUnit.churnTxt }}</span>
      </div>
      <div class="ly-dsub">
        <b>{{ selUnit.when }}</b> · {{ selUnit.dev }}
        <template v-if="selUnit.prevGap"> · от предыдущей {{ selUnit.prevGap }}</template>
        <template v-if="selUnit.nextGap"> · до следующей {{ selUnit.nextGap }}</template>
      </div>
      <div class="ly-path">
        <span v-for="p in selUnit.path" :key="p.b" class="ly-pt" :class="{ 'ly-reach': p.reach, 'ly-on': p.churn, 'ly-act': focusBlock === p.b }"
              :title="p.title" @click="focusBlock = p.b">{{ p.b + 1 }}</span>
      </div>
      <div class="ly-shown">
        <div class="ly-sh-h">Показано сессии{{ selUnit.u.variant ? ' · вариант ' + selUnit.u.variant : '' }}</div>
        <!-- заголовок по тому же правилу, что плашки и решётка: пустой — «без подмены» / «нет данных» -->
        <div class="ly-sh-t" :class="{ 'ly-none': selUnit.head.none }">{{ selUnit.head.t }}</div>
        <div v-if="selUnit.sub" class="ly-sh-s">{{ selUnit.sub }}</div>
        <div class="ly-sh-src">{{ selUnit.source }}</div>
      </div>
      <div v-if="selUnit.conv" class="ly-dsub">Конверсия: {{ selUnit.conv }}</div>
    </div>
    <div v-else-if="blockCard" class="detail ly-detail" aria-live="polite">
      <div class="dhead">
        <span class="big">{{ blockCard.n }}</span>
        <span class="delta">{{ blockCard.lab }} · из {{ blockCard.ses }} {{ plural(blockCard.ses, SES_GEN) }} {{ range ? 'в окне' : 'столбца' }} · {{ blockCard.pct }} %</span>
      </div>
      <div class="ly-dsub">{{ blockCard.span }}</div>
      <table class="dtable">
        <thead><tr><th>фраза</th><th>сессий</th><th>доля</th><th style="width:34%"></th></tr></thead>
        <tbody>
          <tr v-for="r in blockCard.byPhrase" :key="'p' + r.k">
            <td>{{ r.k }}</td><td>{{ r.n }}</td><td>{{ r.pct }} %</td>
            <td style="text-align:left"><span class="ly-dbar" :style="{ width: Math.max(2, r.pct) + '%' }"></span></td>
          </tr>
        </tbody>
      </table>
      <table class="dtable">
        <thead><tr><th>заголовок ¦ подзаголовок</th><th>сессий</th><th>доля</th><th style="width:34%"></th></tr></thead>
        <tbody>
          <tr v-for="r in blockCard.byTitle" :key="'t' + r.k">
            <td>{{ r.k }}</td><td>{{ r.n }}</td><td>{{ r.pct }} %</td>
            <td style="text-align:left"><span class="ly-dbar" :style="{ width: Math.max(2, r.pct) + '%' }"></span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// Сцена слоёв: столбец матрицы раскрывается в ряд карточек сессий по датам (DOM + CSS 3D).
// Перенос buildStage / layerbar / renderCardFocus прототипа v14 с реальными сессиями (К2)
// вместо «заходов»: плитка карточки синяя ровно в блоке оттока из reversals(), поэтому число
// синих в блоке b совпадает с ch клетки. Камера и покадровые движения — в LayerCamera.js.
import LayerBar from './LayerBar.vue';
import LayerFlags from './LayerFlags.vue';
import LayerAnalysis from './LayerAnalysis.vue';
import LayerEventMarks from './LayerEventMarks.vue';
import LayerEvents from './LayerEvents.vue';
import LayerTimeline from './LayerTimeline.vue';
import F6Card from './F6Card.vue';
import LayerCamera, { REDUCED, SCALE, TARGET } from './LayerCamera';
import {
  hitOf, keyHit, keyBlock, orderByTime, orderPhrase, orderBlock, orderHit,
  phraseColors, layoutUnits, medFor, medSplit, headStats, deriveEvents, headOf, noChurnTxt, dayLabel,
} from '@/utils/layers';
import { bucketIndex, cumBuckets, adaptiveBuckets } from '@/utils/wordMatrix';
import { plural } from '@/utils/segments';

// Имена битов convMask (К1). Список фиксирован на бэкенде (getStat.js:11-17), в сцену
// его не передают — берём тот же порядок.
const CONV = ['form', 'click to phone', 'click to messendger', 'messenger', 'click contact'];
const DEVS = ['компьютер', 'планшет', 'телефон'];
const SES = ['сессия', 'сессии', 'сессий'];
// подписи островков в соседних дорожках всего на 20 px ниже: ближе этой глубины они накрывают друг друга
const ISL_GAP = 200;
const DAYS = ['день', 'дня', 'дней'];
const MONTHS_F = ['месяц', 'месяца', 'месяцев'];
const MED_BASE = { col: 'столбец', grp: 'группа', all: 'все слова' };
// одна система цветов медианы: плашка, полоса на полу, плитка карточки и древко флага
const C_LO = 'var(--cell-100)', C_MID = 'var(--cell-40)', C_HI = 'var(--ev-goal)';
// цвета типов событий — те же, что у отметок (LayerEventMarks) и панели (LayerEvents)
const EV_C = { conv: 'var(--ev-goal)', chg: 'var(--ev-drop)', mile: 'var(--ev-peak)' };
const mix = (c, a) => `color-mix(in srgb, ${c} ${Math.round(a * 100)}%, transparent)`;
const LANE_SIDE = ['слева', 'посередине', 'справа'];
// ponytail: весы — не больше восьми строк (самые частые фразы): у сегмента «вся таблица»
// фраз сотни, и столбик весов ушёл бы за верх кадра. Нужны все — делать прокручиваемую легенду.
const SCALE_ROWS = 8;
const DEPTH = 1250;
// ponytail: потолок 500 карточек в DOM, виртуализация — если понадобится больше
const CARD_CAP = 500;
const depthFor = n => Math.max(380, Math.min(DEPTH, n * 170));
// Настройки сцены переживают выход и вход в другой столбец (в П это глобальные переменные).
// Сцена пересоздаётся на каждый вход, поэтому храним их в модуле, как HeadGrid свою решётку.
// Новый массив всех сессий значит другой токен или период — тогда начинаем с умолчаний.
const KEEP = ['zMode', 'layerView', 'dayRow', 'railOn', 'phMode', 'evMode', 'sortHit',
  'medMark', 'medAxis', 'medBase', 'storyMode', 'anStroy', 'anKoro', 'anGrid', 'anAttr', 'anWords',
  'anDist', 'anInf', 'anInfOn', 'tlOn', 'tlMode', 'f6On'];
const memory = { sessions: null, prefs: null };
// день — московские сутки от эпохи, поэтому UTC-дата day·сутки и есть московская дата
const monthKey = day => { const d = new Date(day * 864e5); return d.getUTCFullYear() * 12 + d.getUTCMonth(); };
const hhmm = ms => { const d = new Date(ms + 3 * 3600e3); return String(d.getUTCHours()).padStart(2, '0') + ':' + String(d.getUTCMinutes()).padStart(2, '0'); };
const fmt1 = n => String(Math.round(n * 10) / 10).replace('.', ',');
function gapText(g) {
  if (g <= 0) return 'тот же день';
  if (g < 45) return '+' + g + ' ' + plural(g, DAYS);
  const m = Math.round(g / 30);
  return '+' + m + ' ' + plural(m, MONTHS_F);
}

export default {
  name: 'LayerScene',
  components: { LayerBar, LayerFlags, LayerAnalysis, LayerEventMarks, LayerEvents, LayerTimeline, F6Card },
  mixins: [LayerCamera],
  props: {
    column: { type: Object, required: true },         // К4
    blocks: { type: Array, required: true },
    sessions: { type: Array, required: true },        // К2[] фраз столбца, по start
    metric: { type: String, default: 'cum' },         // 'cum' | 'block'
    startBlock: { type: Number, default: null },      // индекс блока клетки или null (вход с шапки)
    geom: { type: Object, default: null },            // К6.geom, px от левого верхнего угла .ins-mwrap
    allSessions: { type: Array, default: () => [] },  // К2[] всех слов — медиана «все слова»
    ruleChanges: { type: Array, default: () => [] },  // [{at, note}] — смены заголовков по снимкам
    cellBounds: { type: Array, default: null },       // границы корзин цвета, как у матрицы
    modalOpen: { type: Boolean, default: false },     // открыта форма или отчёт A/B: клавиши их
    // storyBlock страницы: страница сбрасывает его в null крошкой слова — сцена уходит с «Блок N»
    story: { type: Number, default: null },
    // режим клеток матрицы {dev, delta, medians}: плитки среза красятся ровно как клетка
    cellMode: { type: Object, default: null },
  },
  emits: ['exit', 'story-block'],
  data() {
    if (memory.sessions !== this.allSessions) { memory.sessions = this.allSessions; memory.prefs = null; }
    const kept = memory.prefs || {};
    return {
      CARD_CAP,
      // порядок × шаг: 'time' | 'even' | 'phrase' | 'phtime'
      zMode: 'time', layerView: 'columns', dayRow: false, railOn: true,
      phMode: 'chips', evMode: 'pins',
      sortHit: false, sortDir: 1, sortBlock: null,
      medMark: false, medAxis: 'v', medBase: 'col', medBand: null, medEqGrp: null,
      storyBlock: null, storyMode: 'both',
      anStroy: false, anKoro: false, anGrid: false, anAttr: 'none', anWords: false, anDist: false, anInf: false,
      anInfOn: { say: false, mat: false, fan: false, var: false, casc: false, pair: false },
      evSel: null, tlOn: true, tlMode: null, f6On: false, range: null,
      layerSel: 'all', focusBlock: null,
      sideView: false, scrollZ: 0, flying: false, frontIdx: null, stageW: 900,
      nav: { pct: 0, day: '', text: '' },
      // Окно видимого участка и столбик передней карточки на ленте. Считаются покадрово, но
      // присваиваются только при смене индексов — лента перерисовывается, когда есть что менять.
      tlView: null, tlHere: null,
      ...kept,
      // пришли из клетки — ряд сразу собран по блоку оттока, чтобы подлететь к нужной группе;
      // это часть захода, на выходе вернётся прежнее (П сортОтКлетки 7330, 7386)
      sortHit: this.startBlock !== null || !!kept.sortHit,
    };
  },
  created() {
    this.CARDS = ['карточка', 'карточки', 'карточек'];
    this.SES_GEN = ['сессии', 'сессий', 'сессий'];   // после «из N»
    this.exiting = false;
  },
  computed: {
    g() { return this.geom; },
    nB() { return this.blocks.length; },
    lastRow() { return this.g.rows[this.g.rows.length - 1] || { top: 0, h: 0 }; },
    timeLike() { return this.zMode === 'time' || this.zMode === 'phtime'; },
    byPhrase() { return this.zMode === 'phrase' || this.zMode === 'phtime'; },
    sortOn() { return this.sortHit || this.sortBlock !== null; },
    evenLike() { return this.sideView || this.zMode === 'even' || this.zMode === 'phrase' || this.sortOn; },
    // вдоль стопки слои всегда корешками: широкие столбцы перекрыли бы друг друга
    spine() { return this.sideView || this.layerView === 'spines'; },
    TW() { return this.spine ? 20 : this.g.colW; },
    BX() { return this.g.colLeft - 22; },
    BY() { return this.g.colTop - 50; },
    BW() { return Math.max(this.g.colW, this.TW) + 300; },
    BH() { return this.g.colH + 300; },
    labShift() { return this.g.colLeft - (this.g.labelLeft + this.g.labelW); },
    inSceneEv() { return ['pins', 'joints', 'tint', 'card'].includes(this.evMode); },

    // ---- ряд ----
    chrono() { return orderByTime(this.sessions); },
    chronoIdx() { const m = new Map(); this.chrono.forEach((u, i) => m.set(u.id, i)); return m; },
    // все сессии окна ленты (без окна — весь столбец); по ним считаются «в окне» и карточка блока
    rangeAll() {
      const r = this.range;
      return r ? this.chrono.filter(u => u.day >= r.from && u.day <= r.to) : this.chrono;
    },
    // в сцену идут не больше CARD_CAP самых поздних: тысячи карточек с плитками вешают вкладку
    rangeSessions() {
      const a = this.rangeAll;
      return a.length > CARD_CAP ? a.slice(-CARD_CAP) : a;
    },
    cappedOf() { return this.rangeAll.length > CARD_CAP ? this.rangeAll.length : 0; },
    // лента показывает весь ряд без окна: окно на ней приглушается, а не вырезается
    rowAll() { return this.order(this.chrono); },
    units() { return this.order(this.rangeSessions); },
    rowIdx() { const m = new Map(); this.units.forEach((u, i) => m.set(u.id, i)); return m; },
    rowAllIdx() { const m = new Map(); this.rowAll.forEach((u, i) => m.set(u.id, i)); return m; },
    // столбик ленты → карточка сцены; −1, если карточку отсекли окно или потолок
    tlScene() { const m = this.rowIdx; return this.rowAll.map(u => (m.has(u.id) ? m.get(u.id) : -1)); },
    phColors() { return phraseColors(this.sessions.map(u => u.phrase)); },
    // Вдоль стопки шаг берём из кадра: при трёх сессиях веер во всю ширину, при сотне — колода.
    sideDz() {
      const n = this.units.length;
      if (!this.sideView || n < 2) return null;
      const sp = Math.sin(66 * Math.PI / 180);
      return Math.max(10, Math.min(210, Math.round(this.stageW * 0.82 / (n * sp * 0.92))));
    },
    layout() {
      return layoutUnits(this.units, {
        mode: this.zMode, colW: this.g.colW, sorted: this.sortOn, spine: this.spine,
        dayRow: this.dayRow, laneBy: this.phMode === 'lanes', dzEven: this.sideDz,
      });
    },
    // Первая карточка стоит за срезом, а не в его плоскости: в прототипе глубина по датам
    // начиналась со 110 px, ровная — с одного шага. layoutUnits отдаёт первую на нуле,
    // сдвиг держит контейнер ряда — дети сцены ставят элементы на −item.z, как и карточки.
    zOff() { return this.evenLike ? this.layout.dzEven : 110; },
    fullDepthV() { return this.units.length ? this.layout.maxDepth + this.zOff : 300; },
    maxScroll() { return Math.max(0, this.fullDepthV - 260); },
    // окно ленты: ряд отъезжает вправо, чтобы не наехать на полоску «в окне»
    xOff() { return this.range && this.units.length ? 56 : 0; },
    laneOrder() {
      const cnt = new Map();
      this.units.forEach(u => cnt.set(u.phrase, (cnt.get(u.phrase) || 0) + 1));
      return [...cnt.keys()].sort((a, b) => cnt.get(b) - cnt.get(a) || a.localeCompare(b, 'ru'));
    },

    // ---- срез ----
    sliceTiles() {
      const cells = this.column.cells || [];
      const cum = this.metric === 'cum';
      const pick = c => (c ? (cum ? c.chPc : c.chP) || 0 : 0);
      // шкала матрицы приходит со страницы; без неё — накопленный 0..100 %, простой по столбцу
      const bounds = this.cellBounds || (cum ? cumBuckets() : adaptiveBuckets(Math.max(0, ...cells.map(pick))));
      // как WordMatrix.cellStyle/cellText: прирост Δ — разность с блоком выше, отклонение — от медианы блока
      const cm = this.cellMode || {};
      return this.g.rows.map((r, b) => {
        const v = pick(cells[b]);
        const val = cm.delta ? v - (b > 0 ? pick(cells[b - 1]) : 0) : v;
        const p = Math.round(v * 100);
        const c = cells[b] || {};
        let bg, ink, txt;
        if (cm.dev) {
          const d = val - ((cm.medians && cm.medians[b]) || 0), dp = Math.round(d * 100);
          const k = Math.abs(d) <= 0.05 ? 0 : d > 0.25 ? 40 : d > 0.05 ? 20 : d < -0.25 ? 100 : 60;
          bg = 'var(--cell-' + k + ')'; ink = 'var(--ink-' + k + ')'; txt = dp > 0 ? '+' + dp : String(dp);
        } else {
          const step = bucketIndex(val, bounds) * 20;
          const q = Math.round(val * 100);
          bg = 'var(--seq-' + step + ')'; ink = 'var(--seq-ink-' + step + ')';
          txt = q === 0 ? '—' : cm.delta && q > 0 ? '+' + q : String(q);
        }
        return { b, top: r.top, h: r.h, bg, ink, txt,
          title: this.column.label + ' · ' + this.blocks[b] + '\n' + p + ' % — '
            + (cum ? c.chC : c.ch) + ' из ' + this.nSess(this.column.ses || 0) + '\nклик — из чего сложено это число' };
      });
    },
    rowLabels() {
      return this.g.rows.map((r, b) => {
        const sorted = this.sortBlock === b;
        return { b, top: r.top, h: r.h, name: this.blocks[b], sorted,
          title: sorted ? (this.sortDir === 1 ? this.blocks[b] + ': сперва без оттока здесь. Ещё клик — наоборот'
            : this.blocks[b] + ': сперва с оттоком здесь. Ещё клик — снять сортировку')
            : 'Отсортировать карточки по оттоку в блоке «' + this.blocks[b] + '»' };
      });
    },
    // В срезе отток считается так же, как в клетке: в блоке (простой) или по блок (накопленный).
    inTile() {
      return this.metric === 'cum' ? (u, b) => u.churn >= 0 && u.churn <= b : (u, b) => u.churn === b;
    },
    mixBars() {
      return this.g.rows.map((r, b) => {
        const cnt = new Map();
        this.rangeAll.forEach(u => { if (this.inTile(u, b)) cnt.set(u.phrase, (cnt.get(u.phrase) || 0) + 1); });
        const sum = [...cnt.values()].reduce((a, v) => a + v, 0);
        if (!sum) return null;
        const parts = [...cnt.entries()].sort((a, c) => c[1] - a[1])
          .map(([ph, n]) => ({ ph, n, w: (n / sum * 100).toFixed(2) }));
        return { b, top: r.top + r.h - 7, parts,
          title: this.blocks[b] + ' · из чего сложен\n' + parts.slice(0, 12)
            .map(p => p.ph + ' — ' + p.n + ' · ' + Math.round(p.n / sum * 100) + ' %').join('\n') };
      }).filter(Boolean);
    },
    windowTiles() {
      const ses = this.column.ses || this.sessions.length || 1;
      const bounds = cumBuckets();
      return this.g.rows.map((r, b) => {
        const n = this.rangeAll.filter(u => this.inTile(u, b)).length;
        const step = bucketIndex(n / ses, bounds) * 20;
        return { b, top: r.top, h: r.h, n, bg: 'var(--seq-' + step + ')', ink: 'var(--seq-ink-' + step + ')',
          title: this.blocks[b] + ' · окно\n' + n + ' из ' + ses };
      });
    },
    // по всем сессиям окна ленты, а не по карточкам сцены: потолок 500 не должен менять доли
    phStats() {
      const map = new Map();
      this.rangeAll.forEach(u => {
        let e = map.get(u.phrase);
        if (!e) { e = { ph: u.phrase, n: 0, val: 0 }; map.set(u.phrase, e); }
        e.n++;
        if (u.churn >= 0) e.val++;
      });
      const rank = new Map(this.laneOrder.map((p, i) => [p, i]));
      const list = [...map.values()].sort((a, b) => b.n - a.n || a.ph.localeCompare(b.ph, 'ru'));
      list.forEach(x => { x.rank = rank.has(x.ph) ? rank.get(x.ph) : null; });
      const shown = list.slice(0, 12);
      return { list, shown, rest: list.length - shown.length, tot: list.reduce((a, x) => a + x.val, 0) };
    },

    // ---- медиана ----
    medKey() { return this.sortHit ? keyHit : keyBlock(this.sortBlock); },
    // медиана по фразе считается один раз на фразу, а не на каждую карточку
    medCache() {
      const cache = new Map();
      const units = this.units, key = this.medKey, base = this.medBase, all = this.allSessions;
      return ph => {
        if (!cache.has(ph)) cache.set(ph, medFor(units, base, key, { all, phrase: ph }));
        return cache.get(ph);
      };
    },
    medVM() {
      if (!this.medMark || !this.sortOn || !this.units.length) return [];
      const units = this.units, key = this.medKey, items = this.layout.items;
      const groups = [];
      if (this.byPhrase) {
        let i0 = 0;
        while (i0 < units.length) {
          let j = i0;
          while (j < units.length && units[j].phrase === units[i0].phrase) j++;
          groups.push({ list: units.slice(i0, j), from: i0, ph: units[i0].phrase });
          i0 = j;
        }
      } else groups.push({ list: units, from: 0, ph: null });
      const medLab = hi => (this.sortHit ? (hi ? 'позже' : 'раньше') : (hi ? 'с оттоком' : 'без оттока'));
      const dir = this.sortDir;
      return groups.map(gr => {
        const m = this.medCache(gr.ph);
        // на двоичной мере медиана вырождается в 0 или 1 — граница посередине
        const thr = this.sortHit ? m : 0.5;
        const k = medSplit(gr.list, thr, key, dir);
        const zAt = i => -items[gr.from + i].z;
        const n = gr.list.length;
        const z0 = zAt(0), z1 = zAt(n - 1);
        const step = n > 1 ? (z1 - z0) / (n - 1) : -60;
        const zOf = idx => (idx <= 0 ? z0 - step * 0.5 : idx >= n ? z1 + step * 0.5 : (zAt(idx - 1) + zAt(idx)) / 2);
        const zMed = zOf(k);
        // сессии без оттока у меры «блок оттока» не имеют значения и в раскладку не входят
        const vals = gr.list.filter(u => key !== keyHit || hitOf(u) >= 0).map(key);
        const nLo = vals.filter(v => v < thr).length;
        const nEq = vals.filter(v => v === thr).length;
        const nHi = vals.filter(v => v > thr).length;
        const zEq = zOf(k - nEq);
        const eqTxt = `ниже медианы ${nLo} · ровно на медиане ${nEq} · выше медианы ${nHi}`
          + (this.sortHit ? ' · ниже значит отток раньше' : '');
        const x = this.g.colLeft + this.g.colW / 2 + (items[gr.from].x || 0);
        const a0 = z0 - step * 0.5, a1 = z1 + step * 0.5;
        const bandOf = (i0, i1) => [gr.from + i0, gr.from + i1];
        const first = { n: dir === 1 ? nLo : nHi, t: medLab(dir !== 1), c: dir === 1 ? C_LO : C_HI };
        const last = { n: dir === 1 ? nHi : nLo, t: medLab(dir === 1), c: dir === 1 ? C_HI : C_LO };
        const segs = [];
        const seg = (za, zb, c, cnt, t, band) => {
          const len = Math.abs(zb - za);
          if (len < 6 || !cnt) return;
          segs.push({ k: segs.length, sz: Math.max(za, zb), len, c, n: cnt, t, band, tier: segs.length });
        };
        seg(a0, zEq, first.c, first.n, first.t, bandOf(0, Math.max(0, first.n - 1)));
        seg(zEq, zMed, C_MID, nEq, 'посередине', bandOf(k - nEq, Math.max(0, k - 1)));
        // У меры «блок оттока» хвост без оттока (orderHit ставит его в конец) меры не имеет:
        // последняя полоса и её группа кончаются на последней сессии с оттоком.
        const nM = key === keyHit ? gr.list.filter(u => hitOf(u) >= 0).length : n;
        seg(zMed, key === keyHit ? zOf(nM) : a1, last.c, last.n, last.t, bandOf(k, Math.max(k, nM - 1)));
        // весы: сколько карточек фразы по каждую сторону границы
        const cnt = new Map();
        gr.list.forEach(u => cnt.set(u.phrase, (cnt.get(u.phrase) || 0) + 1));
        const phs = [...cnt.keys()].sort((a, b) => cnt.get(b) - cnt.get(a) || a.localeCompare(b, 'ru')).slice(0, SCALE_ROWS);
        const scales = phs.map((ph, ri) => {
          let hi = 0, lo = 0, eLo = 0, eEq = 0, eHi = 0;
          gr.list.forEach((u, i) => {
            if (u.phrase !== ph) return;
            if (i >= k) hi++; else lo++;
            if (key === keyHit && hitOf(u) < 0) return;
            const v = key(u);
            if (v < thr) eLo++; else if (v > thr) eHi++; else eEq++;
          });
          const arms = [];
          const arm = (cls, c, d) => {
            const len = Math.abs(c * step) - 12;
            if (len < 8 || !c) return;
            arms.push({ cls, n: c, dir: d, len, sz: zMed + d * 12, nsz: zMed + d * (c * Math.abs(step) + 14) });
          };
          arm('lo', lo, 1); arm('hi', hi, -1);
          return { ph, y: this.g.colTop - 52 - ri * 24, arms,
            live: `${ph}: ниже медианы ${eLo} · ровно на медиане ${eEq} · выше медианы ${eHi}`
              + (phs.length > 1 ? `\nпо всему ряду: ${eqTxt}` : '') };
        });
        // горизонтальная: лента на высоте медианного блока вдоль всего ряда
        let ribbon = null;
        const rb = this.medRowBlock(gr.ph);
        if (rb !== null && this.g.rows[rb]) {
          ribbon = { y: this.g.rows[rb].top + this.g.rows[rb].h, h: Math.max(12, Math.abs(a1 - a0)), sz: Math.max(a0, a1) };
        }
        const name = this.sortHit ? 'Блок оттока' : this.blocks[this.sortBlock];
        return { from: gr.from, zMed, zEq, nEq, x, eqTxt, segs, scales, ribbon,
          pill: `${name} · медиана ${MED_BASE[this.medBase]} ${fmt1(m)} · ${n} ${plural(n, SES)}` };
      });
    },
    // Сторона медианы для покраски синей плитки — только при сортировке по блоку оттока:
    // на двоичной мере одного блока «посередине» не бывает, вся колода краснела бы целиком.
    medSideFn() {
      if (!this.medMark || !this.sortHit || !this.units.length) return null;
      const med = this.medCache, byPh = this.byPhrase;
      return u => {
        if (hitOf(u) < 0) return null;
        const m2 = med(byPh ? u.phrase : null), v = keyHit(u);
        return v < m2 ? 'lo' : v > m2 ? 'hi' : 'eq';
      };
    },
    selIndex() { return typeof this.layerSel === 'number' ? this.layerSel : null; },
    // глубина первой границы: к ней перелетаем при включении медианы (px вглубь, ≥ 0)
    medDepth() { return this.medVM.length ? -this.medVM[0].zMed + this.zOff : null; },

    // ---- карточки ----
    // карточки и число дорожек подписей дат (от него зависит высота сцены и островки)
    cardsVM() {
      const units = this.units, lay = this.layout, g = this.g;
      if (!units.length) return { list: [], maxLane: 0 };
      const dense = units.length > 12;
      const colBottom = g.colTop + g.colH;
      const laneZ = [null, null, null, null];
      let lastLabZ = null, lane = 0, lastTagZ = null, lastLabeledMonth = null;
      let maxLane = 0;
      const islStart = new Set(lay.islands.map(x => x.from));
      const perDay = new Map();
      units.forEach(u => perDay.set(u.day, (perDay.get(u.day) || 0) + 1));
      // пауза до предыдущего нового дня в ряду — подпись провала
      const gapOf = new Map();
      let prevDistinct = units[0].day;
      units.forEach(u => { if (!gapOf.has(u.day)) { gapOf.set(u.day, u.day - prevDistinct); prevDistinct = u.day; } });
      const inRowOn = this.dayRow && this.timeLike && !this.sortOn;
      const sideCls = this.sideView ? ' ly-face' : '';
      const medSide = this.medSideFn;
      const rb = this.medMark && this.sortOn && this.medAxis === 'h';
      const evOf = this.cardEv;
      const list = units.map((u, i) => {
        const it = lay.items[i];
        const isSel = this.layerSel === i;
        const wide = !this.spine || isSel;
        const tw = wide ? g.colW : this.TW;
        const color = this.phColor(u.phrase);
        const dim = this.layerSel !== 'all' && !isSel;
        // сторона медианы красит синюю плитку: до медианы красным, на ней синим, после зелёным
        const side = medSide ? medSide(u) : null;
        const md = side ? ' ly-md-' + side : '';
        const runStart = i === 0 || units[i - 1].phrase !== u.phrase;
        const runLen = runStart ? (() => { let n2 = 1; while (i + n2 < units.length && units[i + n2].phrase === u.phrase) n2++; return n2; })() : 0;
        const inRow = inRowOn && it.rowN > 1;
        const tagFar = lastTagZ === null || Math.abs(it.z - lastTagZ) >= 130;
        const wantTag = isSel || inRow || (it.first && tagFar);
        if (wantTag && !inRow) lastTagZ = it.z;
        const name = 'Сессия ' + (this.chronoIdx.get(u.id) + 1);
        let tag = null;
        if (wide && wantTag) {
          tag = inRow ? hhmm(u.start) : name;
          if (this.phMode === 'chips' && !inRow) tag += ' · ' + u.phrase;
        }
        // даты на линии: при плотном веере только начало месяца, острова и длинные паузы;
        // при сортировке ряд не хронологический — время на линии не показываем вовсе
        let date = null, gap = null;
        if (!this.sortOn && this.timeLike) {
          const gd = gapOf.get(u.day) || 0;
          const mk = monthKey(u.day);
          const newMonth = mk !== lastLabeledMonth;
          const near = lastLabZ !== null && Math.abs(it.z - lastLabZ) < 190;
          const wantDate = it.first
            && (!dense || i === 0 || i === units.length - 1 || newMonth || gd >= 14 || islStart.has(i))
            && (!dense || !near || islStart.has(i));
          const wantGap = wantDate && i > 0 && gd > 0 && (!dense || gd >= 14);
          if (wantDate) {
            lastLabeledMonth = mk;
            lane = laneZ.length - 1;
            for (let L = 0; L < laneZ.length; L++) {
              if (laneZ[L] === null || Math.abs(it.z - laneZ[L]) >= 190) { lane = L; break; }
            }
            laneZ[lane] = it.z;
            lastLabZ = it.z;
            if (lane > maxLane) maxLane = lane;
          }
          const laneY = lane * 54;
          // на развёрнутой карточке дата уже написана под ней самой
          if (wantDate && !wide) {
            const cnt = perDay.get(u.day) || 1;
            date = { txt: dayLabel(u.day), cnt, top: colBottom + 24 + laneY - this.BY,
              tip: cnt > 1 ? dayLabel(u.day) + ': ' + cnt + ' ' + plural(cnt, SES) + ' в этот день' : null };
          }
          if (wantGap) gap = { txt: gapText(gd) + (gd > 3 ? ' ⋯' : ''), long: gd > 14, top: colBottom + laneY + 48 - this.BY };
        } else if (!this.sortOn && !this.spine && !wide) {
          date = { txt: dayLabel(u.day), cnt: 1, top: colBottom + 8 - this.BY, tip: null };
        }
        let medRowY = null;
        if (rb) {
          const b = this.medRowBlock(this.byPhrase ? u.phrase : null);
          if (b !== null && g.rows[b]) medRowY = g.rows[b].top + g.rows[b].h - this.BY - 1;
        }
        const lw = tw + 26;
        return {
          key: u.id, i, u, isSel, wide, tw, lw, color,
          sz: -it.z + (isSel ? 55 : 0), kx: it.x, laneDX: (it.lane || 0) * (lay.laneW || 0),
          baseop: dim ? '0.13' : '1',
          cls: (dim ? 'ly-dim' : '') + (this.spine && !wide ? ' ly-spine' : '') + sideCls + md,
          delay: REDUCED ? '0ms' : Math.min(600, (i + 1) * (units.length > 20 ? 14 : 55)) + 'ms',
          origin: `${9 + lw / 2}px ${37 + g.colH / 2}px`,
          phcap: this.phMode === 'mix' && wide && runStart && (i === 0 || runLen >= 2),
          tag, tagTitle: name + ' · ' + u.phrase,
          tiles: g.rows.map((r, b) => ({ b, top: r.top - this.BY, h: r.h, on: hitOf(u) === b,
            title: name + ' · ' + this.blocks[b] + '\n' + u.phrase + '\n'
              + (hitOf(u) === b ? 'отток в этом блоке' : hitOf(u) < 0 ? noChurnTxt(u) : 'отток в «' + this.blocks[hitOf(u)] + '»')
              + '\n' + dayLabel(u.day) + ', ' + hhmm(u.start) })),
          medRowY, dateLab: dayLabel(u.day), date, gap, tint: evOf.has(i) ? this.tintOf(evOf.get(i)) : null,
          cap: (isSel || (this.evMode === 'card' && wide)) ? {
            name, date: dayLabel(u.day) + ', ' + hhmm(u.start),
            churn: u.churn >= 0 ? 'отток: ' + this.blocks[u.churn] : noChurnTxt(u),
          } : null,
        };
      });
      return { list, maxLane };
    },
    // «заливка» и «картотека»: события сессии красят подложку её карточки (прототип 4818–4850),
    // поэтому цвет гаснет и выезжает вместе с карточкой
    cardEv() {
      const m = new Map();
      if (this.evMode !== 'tint' && this.evMode !== 'card') return m;
      this.events.forEach(e => {
        if (e.at !== 'in' || !this.rowIdx.has(e.sid)) return;
        const k = this.rowIdx.get(e.sid);
        if (!m.has(k)) m.set(k, []);
        m.get(k).push(e);
      });
      return m;
    },
    maxLane() { return this.cardsVM.maxLane; },
    islTop() { return this.g.colTop + this.g.colH + 30 + (this.maxLane + 1) * 54; },
    groupCaps() {
      const out = [];
      const units = this.units, items = this.layout.items;
      units.forEach((u, i) => {
        if (i > 0 && units[i - 1].phrase === u.phrase) return;
        let n = 1;
        while (i + n < units.length && units[i + n].phrase === u.phrase) n++;
        out.push({ i, ph: u.phrase, cards: n, x: items[i].x || 0, sz: -items[i].z });
      });
      return out;
    },
    islandsVM() {
      // как П 4867: при сортировке по блоку оттока островки остаются, снимает их только сортировка по блоку
      if (this.zMode !== 'time' || this.units.length < 2 || this.sortBlock !== null) return [];
      // подпись — в первую из трёх дорожек, где соседняя подпись дальше 260 px по глубине (шаг П),
      // и не ближе ISL_GAP к любой другой; иначе островок остаётся без подписи. При сортировке
      // островки из разных месяцев сходятся в ряду (глубины идут не по порядку), и подписи
      // ложились друг на друга: 25 пересечений из 35 против 8 подписей у П
      const taken = [[], [], []];
      return this.layout.islands.filter(is => is.n >= 2).map((is, k) => {
        const span = is.z1 - is.z0;
        const mid = is.z0 + span / 2;
        const clear = taken.every(t => t.every(z => Math.abs(mid - z) >= ISL_GAP));
        const lane = clear ? taken.findIndex(t => t.every(z => Math.abs(mid - z) >= 260)) : -1;
        if (lane >= 0) taken[lane].push(mid);
        return { k, sz: -is.z0, h: Math.max(10, span), lane, lsz: -mid,
          txt: (is.day1 !== is.day0 ? dayLabel(is.day0) + ' – ' + dayLabel(is.day1) : dayLabel(is.day0))
            + ' · ' + is.n + ' ' + plural(is.n, SES) };
      });
    },

    // ---- высота и отступы ----
    rowStep() { const r = this.g.rows; return r.length > 1 ? r[1].top - r[0].top : 32; },
    // ярусы флагов уходят вверх от шапки столбца — на столько же поднимаем сцену
    storyHead() {
      if (this.storyBlock === null || !this.units.length) return 0;
      return this.g.colH + Math.max(24, Math.min(42, this.rowStep - 2)) + 40;
    },
    stageH() {
      const minH = this.g.colTop + this.g.colH + 80;
      // ponytail: под нижние подписи событий берём три дорожки с запасом (прототип evExtra 5079), точный
      // счёт дорожек живёт в LayerEventMarks — пробрасывать его, если запас окажется мал.
      // В П запас только у «вех» (beams = !pins, 4976), но у «заливки» и «картотеки» подписи
      // стоят на той же высоте (labelY), поэтому запас берём для всех трёх режимов.
      const evExtra = this.inSceneEv && this.evMode !== 'joints' && this.events.length ? 8 + 2 * 22 + 56 : 0;
      return Math.max(minH, this.padTop() + this.g.colH * SCALE + 132 + (this.maxLane + 1) * 54 + evExtra);
    },

    // ---- детям сцены ----
    flagsMode() {
      return { plates: this.storyMode !== 'panel', stroy: this.anStroy, koro: this.anKoro,
        grid: this.anGrid, attr: this.anAttr, words: this.anWords };
    },
    panels() { return { read: this.storyMode !== 'plates', dist: this.anDist, inf: this.anInf }; },
    stats() { return this.storyBlock === null ? null : headStats(this.units, this.anAttr, this.nB); },
    // события по всему столбцу: пороги конверсий считаются от всех; окно их только фильтрует
    events() { return deriveEvents(this.chrono, { convTypes: CONV, ruleChanges: this.ruleChanges }); },
    // при сортировке по блоку события «между сессиями» теряют смысл: соседи больше не соседи
    // по времени (П evVisible 6206). «По фразам» и «блок оттока» их не прячут — пара в разных местах ряда
    evShown() { return this.sortBlock === null ? this.events : this.events.filter(e => e.at === 'in'); },
    barState() {
      return {
        label: this.column.label, sideView: this.sideView, zMode: this.zMode, sortOn: this.sortOn,
        sortBlock: this.sortBlock, sortDir: this.sortDir, sortHit: this.sortHit,
        blockName: this.sortBlock !== null ? this.blocks[this.sortBlock] : '',
        layerView: this.layerView, phMode: this.phMode, evMode: this.evMode, timeLike: this.timeLike,
        dayRow: this.dayRow, maxScroll: this.maxScroll, medMark: this.medMark, medAxis: this.medAxis,
        medBase: this.medBase, storyBlock: this.storyBlock, storyMode: this.storyMode,
        anWords: this.anWords, anInf: this.anInf, anDist: this.anDist, anStroy: this.anStroy,
        anKoro: this.anKoro, anGrid: this.anGrid, anAttr: this.anAttr,
        railOn: this.railOn, tlOn: this.tlOn, f6On: this.f6On,
      };
    },

    // ---- карточка сбоку ----
    selUnit() {
      if (typeof this.layerSel !== 'number') return null;
      const u = this.units[this.layerSel];
      if (!u) return null;
      const ci = this.chronoIdx.get(u.id);
      const prev = this.chrono[ci - 1], next = this.chrono[ci + 1];
      const conv = CONV.filter((_, k) => u.convMask & (1 << k));
      const head = headOf(u);
      return {
        u, name: 'Сессия ' + (ci + 1), head,
        // у служебного заголовка сырой подзаголовок всё же показываем, если он записан
        sub: head.none ? u.subtitle || null : head.s || '—',
        churnTxt: u.churn >= 0 ? 'отток в блоке «' + this.blocks[u.churn] + '»'
          : u.reached < 0 ? 'нет блоков: сессия не дошла ни до одного блока'
            : 'без оттока: разворот вверх или повтор веса, reversals() отток не засчитал',
        when: dayLabel(u.day) + ', ' + hhmm(u.start), dev: DEVS[u.dev] || 'устройство неизвестно',
        prevGap: prev ? gapText(u.day - prev.day) : null,
        nextGap: next ? gapText(next.day - u.day) : null,
        path: this.blocks.map((name, b) => ({ b, reach: u.reached >= b, churn: u.churn === b,
          title: name + (u.churn === b ? ' — отток' : u.reached >= b ? ' — дошла' : ' — не дошла') })),
        source: u.shownSource === 'log' ? 'записано' : u.shownSource === 'snapshot' ? 'восстановлено по снимку'
          : u.shownSource === 'current' ? 'по текущим правилам' : 'нет данных о показе',
        conv: conv.join(', '),
      };
    },
    blockCard() {
      if (this.focusBlock === null || typeof this.layerSel === 'number') return null;
      const b = this.focusBlock;
      const list = this.rangeAll.filter(u => this.inTile(u, b));   // не выборка карточек: число сверяется с ch
      // окно ленты: число, знаменатель, проценты и даты по одному набору — сессиям окна
      const ses = this.range ? this.rangeAll.length : this.column.ses || this.sessions.length;
      const pctOf = n => (list.length ? Math.round(n / list.length * 100) : 0);
      const tally = keyOf => {
        const m = new Map();
        list.forEach(u => { const k = keyOf(u); m.set(k, (m.get(k) || 0) + 1); });
        const rows = [...m.entries()].sort((a, c) => c[1] - a[1]).map(([k, n]) => ({ k, n, pct: pctOf(n) }));
        const top = rows.slice(0, 14);
        const rest = rows.slice(14).reduce((a, r) => a + r.n, 0);
        if (rest) top.push({ k: 'ещё ' + (rows.length - 14), n: rest, pct: pctOf(rest) });
        return top;
      };
      const all = this.rangeAll;
      const d0 = all.length ? all[0].day : 0;
      const d1 = all.length ? all[all.length - 1].day : 0;
      return {
        n: list.length, ses, pct: ses ? Math.round(list.length / ses * 100) : 0,
        lab: plural(list.length, SES) + (this.metric === 'cum' ? ' с оттоком по «' : ' с оттоком в «') + this.blocks[b] + '»',
        span: !all.length ? '' : d0 === d1 ? dayLabel(d0)
          : dayLabel(d0) + ' — ' + dayLabel(d1) + ' · ' + (d1 - d0) + ' ' + plural(d1 - d0, DAYS),
        byPhrase: tally(u => u.phrase),
        byTitle: tally(u => { const h = headOf(u); return h.none ? h.t : h.t + ' ¦ ' + (h.s || '—'); }),
      };
    },
  },
  watch: {
    // любая перестройка ряда переставляет карточки: старые номера указывают не туда
    units() {
      this.medBand = null;
      if (typeof this.layerSel === 'number' && this.layerSel >= this.units.length) this.layerSel = 'all';
    },
    storyBlock(v) { this.$emit('story-block', v); },
    // крошка слова на странице: снять «Блок N», выбор и перекадрировать (прототип 6636–6641)
    story(v) {
      if (v !== null || this.storyBlock === null) return;
      this.clearLayer();
      this.storyBlock = null;
      this.rebuild(420);
    },
    geom() { this.rebuild(); },
  },
  mounted() {
    this.measureW();
    // Esc слушаем на window: он срабатывает после всех слушателей document, и дети (попап Ф6,
    // подсказка), закрывшие своё окно, успевают пометить событие preventDefault.
    this.onKeyDown = e => {
      if (e.key !== 'Escape' || e.defaultPrevented) return;
      // открытую модалку A/B закрывает Esc страницы, из слоёв при этом не выходим
      if (this.modalOpen) return;
      this.exit();
    };
    this.onResize = () => { this.measureW(); this.rebuild(0); };
    this.moveH = e => this.onMove(e);
    this.upH = () => this.onUp();
    this.wheelH = e => this.onWheel(e);
    window.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('mousemove', this.moveH);
    document.addEventListener('mouseup', this.upH);
    window.addEventListener('resize', this.onResize);
    this.$refs.stage.addEventListener('wheel', this.wheelH, { passive: false });
    // Дети сцены (флаги, отметки событий) дорисовывают свои элементы сами — подхватываем
    // их по мутациям DOM, раз за кадр.
    this.mo = new MutationObserver(() => this.scheduleRefresh());
    this.mo.observe(this.$refs.track, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['data-sz', 'data-kind', 'data-baseop', 'data-kx'] });
    // высота ещё меняется от панелей детей (Ф6, события, лента) — следим за корнем
    this.wrapEl = this.$el.closest('.ins-mwrap');
    if (this.wrapEl && window.ResizeObserver) {
      this.ro = new ResizeObserver(() => this.syncWrap());
      this.ro.observe(this.$el);
    }
    this.setCam({ x: 0, y: 0, z: 0, tx: 0, ty: 0, s: 1 });
    this.refresh();
    requestAnimationFrame(() => {
      if (this.exiting) return;
      this.explode();
      const b = this.startBlock;
      this.arcTo(this.focusTarget(TARGET.x, TARGET.y), 1400, { arc: -16, dolly: 130 },
        b === null ? undefined : () => this.flyToBlock(b));
    });
  },
  beforeUnmount() {
    const prefs = Object.create(null);
    KEEP.forEach(k => { prefs[k] = this[k]; });
    if (this.startBlock !== null) prefs.sortHit = !!(memory.prefs && memory.prefs.sortHit);
    memory.prefs = prefs;
    // выход крошкой размонтирует сцену сразу: отложенные кадры и таймеры больше ничего не трогают
    this.exiting = true;
    window.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('mousemove', this.moveH);
    document.removeEventListener('mouseup', this.upH);
    window.removeEventListener('resize', this.onResize);
    if (this.mo) this.mo.disconnect();
    if (this.ro) this.ro.disconnect();
    if (this.wrapEl) this.wrapEl.style.minHeight = '';
    cancelAnimationFrame(this.refreshRAF);
  },
  methods: {
    px(o) { const out = {}; Object.keys(o).forEach(k => { out[k] = o[k] + 'px'; }); return out; },
    nSess(n) { return n + ' ' + plural(n, SES); },
    plural,
    phColor(ph) { return this.phColors[ph] || 'var(--ph0)'; },
    order(list) {
      const dir = this.sortDir;
      let a = this.byPhrase
        ? orderPhrase(list, this.zMode === 'phrase' && this.sortBlock !== null ? this.sortBlock : null, dir)
        : orderByTime(list);
      if (this.sortHit) a = orderHit(a, dir, this.byPhrase);
      else if (this.sortBlock !== null) a = orderBlock(a, this.sortBlock, dir, this.byPhrase);
      return a;
    },
    // уровень горизонтальной медианы: медианный блок оттока или сам сортируемый блок
    medRowBlock(ph) {
      if (!(this.medMark && this.sortOn && this.medAxis === 'h' && this.units.length)) return null;
      if (!this.sortHit) return this.sortBlock;
      return Math.max(1, Math.min(this.nB, Math.round(this.medCache(ph)))) - 1;
    },
    measureW() { if (this.$refs.stage) this.stageW = this.$refs.stage.clientWidth || 900; },
    // ---- мост к движку камеры ----
    padTop() {
      const n = this.units.length || 6;
      return Math.max(120, Math.min(250, 60 + Math.round((depthFor(n) + 110) * 0.14)))
        + Math.round(this.storyHead * SCALE);
    },
    fullDepth() { return this.fullDepthV; },
    flagGaps() {
      if (this.storyBlock === null || !this.units.length) return [0, 0];
      const GAP1 = Math.max(this.g.colW, this.TW) + 54;
      const plates = this.storyMode !== 'panel' && !this.anStroy && !this.anKoro;
      return [plates || this.anStroy ? GAP1 : 0, this.anKoro ? (this.anStroy ? GAP1 + 330 : GAP1) : 0];
    },
    refresh() {
      const E = this.E;
      E.zOff = this.zOff; E.xOff = this.xOff;
      this.collectScrollEls();
      if (E.exploded) { this.placeStatic(); this.shiftLabels(true); }
      this.applyScroll();
      this.applyCam();
      this.scheduleThin();
      this.syncWrap();
    },
    // Хост сцены лежит поверх матрицы абсолютно; когда сцена выше матрицы, растягиваем
    // обёртку матрицы, иначе сцена наехала бы на решётку под ней.
    syncWrap() {
      if (this.wrapEl && !this.exiting) this.wrapEl.style.minHeight = this.$el.offsetHeight + 'px';
    },
    scheduleRefresh() {
      if (this.refreshRAF) return;
      this.refreshRAF = requestAnimationFrame(() => { this.refreshRAF = null; this.refresh(); });
    },
    // после смены состояния: дождаться DOM, расставить и перекадрировать
    rebuild(dur) {
      this.$nextTick(() => {
        if (this.exiting) return;
        this.scrollZ = Math.max(0, Math.min(this.maxScroll, this.scrollZ));
        this.refresh();
        this.reframe(dur);
      });
    },
    // хронологический номер сессии: один и тот же в метке, панели чтения, окне и ленте
    numOf(u) { return this.chronoIdx.get(u.id) + 1; },
    laneName(k) { return this.laneOrder.length <= 3 && LANE_SIDE[k] ? LANE_SIDE[k] : 'дорожка ' + (k + 1); },
    tintOf(list) {
      const tint = this.evMode === 'tint';
      const on = list.some(e => e.id === this.evSel);
      const cols = list.map(e => EV_C[e.kind] || 'var(--ev-peak)');
      const last = cols[cols.length - 1];
      let grad;
      if (tint) {
        grad = cols.length === 1
          ? `${mix(cols[0], on ? 0.56 : 0.34)} 0%, ${mix(cols[0], on ? 0.24 : 0.15)} 46%, ${mix(cols[0], on ? 0.07 : 0.04)} 100%`
          : cols.map((c, k) => `${mix(c, k === 0 ? (on ? 0.56 : 0.34) : (on ? 0.48 : 0.30))} ${Math.round(k / (cols.length - 1) * 70)}%`)
            .join(', ') + `, ${mix(last, on ? 0.08 : 0.05)} 100%`;
      } else {
        // «картотека»: цвет только у нижней кромки, где в карточку упирается столб
        grad = cols.length === 1
          ? `${mix(cols[0], on ? 0.38 : 0.22)} 0%, ${mix(cols[0], on ? 0.12 : 0.07)} 22%, ${mix(cols[0], 0)} 46%`
          : cols.map((c, k) => `${mix(c, k === 0 ? (on ? 0.38 : 0.22) : (on ? 0.32 : 0.19))} ${Math.round(k / (cols.length - 1) * 30)}%`)
            .join(', ') + `, ${mix(last, 0)} 50%`;
      }
      return {
        background: `linear-gradient(to top, ${grad}), var(--plate)`,
        borderColor: mix(cols[0], on ? 0.9 : tint ? 0.6 : 0.55), borderWidth: on ? '2px' : '1.5px',
        boxShadow: !on ? undefined : tint ? `0 0 0 2px ${mix(cols[0], 0.55)}, 0 16px 40px var(--shadow-sm)`
          : `0 0 0 2px ${mix(cols[0], 0.45)}, 0 22px 54px var(--shadow-md)`,
      };
    },
    // Подсказка плиток: делегированием, текст из data-tip. Первая строка — заголовком.
    onTip(e) {
      const tip = this.$refs.tip;
      if (!tip) return;
      const t = e && e.target && e.target.closest ? e.target.closest('[data-tip]') : null;
      if (!t || this.E.drag) { if (!tip.hidden) tip.hidden = true; return; }
      const [head, ...rest] = t.dataset.tip.split('\n');
      tip.querySelector('b').textContent = head;
      tip.querySelector('span').textContent = rest.join('\n');
      tip.hidden = false;
      const r = this.$el.getBoundingClientRect();
      const x = Math.min(e.clientX - r.left + 14, r.width - tip.offsetWidth - 4);
      tip.style.left = Math.max(0, x) + 'px';
      tip.style.top = (e.clientY - r.top + 16) + 'px';
    },
    // глубина карточки ряда: при этом scrollZ она стоит в плоскости среза
    zForIdx(i) {
      const it = this.layout.items;
      if (!it.length) return 0;
      return it[Math.max(0, Math.min(it.length - 1, i))].z + this.zOff;
    },
    // столбик ленты → карточка сцены; если её отсекло окно или потолок — ближайшая видимая
    tlSceneIdx(i) {
      const tl = this.tlScene;
      for (let d = 0; d < tl.length; d++) {
        if (tl[i - d] !== undefined && tl[i - d] >= 0) return tl[i - d];
        if (tl[i + d] !== undefined && tl[i + d] >= 0) return tl[i + d];
      }
      return 0;
    },
    onScrolled() {
      const items = this.layout.items, sc = this.scrollZ, off = this.zOff;
      let best = -1, bestD = 1e9, fi = null, fd = Infinity;
      items.forEach((it, i) => {
        const z = -(it.z + off) + sc;
        const d = Math.abs(z);
        if (d < fd) { fd = d; fi = i; }
        if (z <= 60 && d < bestD) { bestD = d; best = i; }
      });
      this.nav.pct = this.maxScroll > 0 ? sc / this.maxScroll * 100 : 0;
      // дата жирной, как <b> в П 7434
      this.nav.day = this.maxScroll < 40 ? '' : (best >= 0 ? dayLabel(this.units[best].day) : '—');
      this.nav.text = this.maxScroll < 40 ? '' : ' · ' + (best + 1) + ' из ' + this.units.length;
      const front = typeof this.layerSel === 'number' ? this.layerSel : fi;
      if (front !== this.frontIdx) this.frontIdx = front;
      // лента: отрезок карточек, реально видимых в сцене (z от 40 до −900), — «бегунок»
      const tl = this.tlScene;
      let a = -1, b = -1;
      if (this.E.exploded && this.maxScroll >= 40) {
        for (let i = 0; i < tl.length; i++) {
          const it = tl[i] >= 0 ? items[tl[i]] : null;
          if (!it) continue;
          const z = -(it.z + off) + sc;
          if (z <= 40 && z >= -900) { if (a < 0) a = i; b = i; }
        }
      }
      const v = this.tlView;
      if (a < 0 ? v !== null : !v || v.a !== a || v.b !== b) this.tlView = a < 0 ? null : { a, b };
      // курсор — на столбике передней карточки, той же, что у панели чтения
      const u = front === null ? null : this.units[front];
      const here = u && this.rowAllIdx.has(u.id) ? this.rowAllIdx.get(u.id) : null;
      if (here !== this.tlHere) this.tlHere = here;
    },

    // ---- панель ----
    onAct(name, v) {
      const flip = k => { this[k] = !this[k]; };
      switch (name) {
        case 'front': this.setSide(false); this.$nextTick(() => { this.refresh(); this.arcTo(this.focusTarget(0, 0), 620); }); return;
        case 'side': this.toSide(!this.sideView); return;
        case 'zMode': this.zMode = v; this.clearLayer(); break;
        case 'unsort': this.sortBlock = null; this.sortDir = 1; break;
        case 'layerView': this.layerView = v; break;
        case 'phMode': this.phMode = v; break;
        case 'evMode': this.setEvMode(v); return;
        case 'dayRow': flip('dayRow'); break;
        case 'toStart': this.scrollZ = 0; this.applyScroll(); this.scheduleThin(); return;
        case 'cycleHit': this.cycleHit(); return;
        case 'medMark': flip('medMark'); if (this.medMark) { this.$nextTick(() => { this.refresh(); this.flyToMed(); }); return; } break;
        // любое касание настроек медианы — «хочу посмотреть на медиану»: камера к границе
        case 'medAxis': this.medAxis = v; this.$nextTick(() => { this.refresh(); this.flyToMed(); }); return;
        case 'medBase': this.medBase = v; this.$nextTick(() => { this.refresh(); this.flyToMed(); }); return;
        case 'toMed': this.flyToMed(); return;
        case 'storyMode': this.storyMode = v; break;
        case 'anWords': flip('anWords'); break;
        case 'anInf':
          flip('anInf');
          // как в прототипе (6846–6850): при включении «влияния» с пустым набором вкладок включаем связку
          if (this.anInf && !Object.values(this.anInfOn).some(Boolean)) this.anInfOn = { ...this.anInfOn, say: true, mat: true, fan: true, var: true };
          return;
        case 'anDist': flip('anDist'); return;
        case 'anStroy': flip('anStroy'); this.rebuild(420); return;
        case 'anKoro': flip('anKoro'); this.rebuild(420); return;
        case 'anGrid': flip('anGrid'); return;
        case 'anAttr': this.anAttr = v; break;
        case 'railOn': flip('railOn'); break;
        case 'tlOn': flip('tlOn'); return;
        case 'f6On': flip('f6On'); return;
        default: return;
      }
      this.rebuild();
    },
    // Смена вида меняет шаг ряда (в торце он от кадра, 10 px против 24+ в лоб). Пролёт держим
    // в карточках, а не в px: иначе после подлёта к блоку торец уезжал в хвост ряда без оттока,
    // все плашки оказывались пролетевшими и стояли отдельной кучкой перед срезом. У П тот же
    // перенос в px (49 → 118 из 196), на его данных просто не видно.
    // Пролёт держим дробным номером карточки: k и доля пути до k+1, до первой — доля её глубины
    // (в начале ряда пролёт 0 остаётся 0, первая карточка не встаёт в срез).
    setSide(on) {
      const n = this.layout.items.length, s = this.scrollZ;
      let k = -1;
      while (k + 1 < n && this.zForIdx(k + 1) <= s) k++;
      const at = i => (i < 0 ? 0 : this.zForIdx(i));
      const fr = (a, b) => (b > a ? (s - a) / (b - a) : 0);
      const f = k + 1 < n ? fr(at(k), at(k + 1)) : 0;
      this.sideView = on;
      if (!n) return;
      const z = k + 1 < n ? at(k) + f * (at(k + 1) - at(k)) : at(k);
      this.scrollZ = Math.round(Math.max(0, Math.min(this.maxScroll, z)));
    },
    toSide(on) {
      this.setSide(on);
      this.$nextTick(() => {
        // П перестраивает сцену заново, и карточки сразу стоят на новой глубине. У нас Vue
        // правит те же узлы, и переход .ly-l3 тянул бы их со старой глубины: fitSide в конце
        // полёта мерил бы колоду на полпути и отодвигал камеру в разы дальше
        const cam = this.$refs.cam;
        if (cam) cam.classList.add('ly-noanim');
        this.refresh();
        if (cam) { void cam.offsetWidth; if (!this.flying) cam.classList.remove('ly-noanim'); }
        if (on) this.arcTo(this.sideTarget(), 1900, { arc: 24, dolly: 220 }, () => this.fitSide());
        else this.arcTo(this.focusTarget(TARGET.x, TARGET.y), 1500, { arc: -18, dolly: 150 });
      });
    },
    setEvMode(m) {
      this.evMode = m; this.evSel = null;
      this.setPull(null, null);
      this.rebuild();
      // «лента» и «воронка» живут в панели под сценой, а сцена выше экрана: подводим панель к глазам
      if (m !== 'off' && !this.inSceneEv) this.$nextTick(() => requestAnimationFrame(() => this.scrollToEv()));
    },
    scrollToEv() {
      const c = this.$refs.events, el = c && c.$el;
      if (this.exiting || !el || !el.getBoundingClientRect) return;
      const r = el.getBoundingClientRect();
      if (r.height < 4 || (r.top >= 0 && r.bottom <= window.innerHeight)) return;
      el.scrollIntoView({ block: 'center', behavior: REDUCED ? 'auto' : 'smooth' });
    },
    // клик по подписи блока в срезе: сперва без оттока → с оттоком → снять
    cycleSort(b) {
      this.sortHit = false;
      if (this.sortBlock !== b) { this.sortBlock = b; this.sortDir = 1; }
      else if (this.sortDir === 1) this.sortDir = -1;
      else { this.sortBlock = null; this.sortDir = 1; }
      this.clearLayer();
      this.rebuild();
    },
    // три клика, как у подписей блоков: раньше → позже → снять
    cycleHit() {
      if (!this.sortHit) { this.sortHit = true; this.sortDir = 1; this.sortBlock = null; }
      else if (this.sortDir === 1) this.sortDir = -1;
      else { this.sortHit = false; this.sortDir = 1; }
      // выбор среза переживает сортировку, как в П (cycleHit не трогает layerSel):
      // карточка «N сессий с оттоком…» и приглушение остаются. Выбранная карточка — нет:
      // после пересортировки на её месте другая
      if (this.layerSel !== 'slice') this.clearLayer();
      this.rebuild();
    },
    clearLayer() {
      this.layerSel = 'all'; this.focusBlock = null; this.evSel = null;
      if (this.E.pullSel !== null || this.E.splitSel !== null) this.setPull(null, null);
    },
    // Клик по плитке среза: тексты этого блока. Опираемся на storyBlock, а не на layerSel:
    // тот сбрасывается сортировкой, и повторный клик переставал бы выключать тексты.
    pickSlice(b) {
      if (this.storyBlock === b) { this.layerSel = 'all'; this.focusBlock = null; this.storyBlock = null; }
      else { this.layerSel = 'slice'; this.focusBlock = b; this.storyBlock = b; }
      if (this.layerSel === 'all') { this.evSel = null; this.setPull(null, null); }
      // флаги поднимают шапку сцены — перекадрируемся, иначе верхние ярусы за краем
      this.rebuild(420);
    },
    // Клик по плитке карточки. Та же карточка и та же плитка — снимаем выделение целиком.
    toggleLayer(i, b) {
      const E = this.E;
      if (this.layerSel === i) {
        if (this.focusBlock === b) { this.clearLayer(); this.applyLayer(); return; }
        this.focusBlock = b;
      } else if (E.pullSel === i) {
        this.clearLayer();
      } else {
        if (E.pullSel !== null) this.evSel = null;
        this.layerSel = i; this.focusBlock = b;
      }
      this.applyLayer();
    },
    // Сцену пересобираем в том положении, в каком она есть, и лишь через кадр трогаем
    // выдвижение — иначе карточка окажется на месте мгновенно и доводчику нечего доводить.
    applyLayer() {
      const want = typeof this.layerSel === 'number' && this.E.exploded ? this.layerSel : null;
      this.$nextTick(() => {
        this.refresh();
        if (want !== this.E.pullSel) requestAnimationFrame(() => requestAnimationFrame(() => this.setPull(want, null)));
      });
    },
    // выбор группы медианы: раздвинуть ряд вокруг неё, повторный клик сдвигает обратно
    setMedBand(band) {
      const same = this.medBand && this.medBand[0] === band[0] && this.medBand[1] === band[1];
      this.medBand = same ? null : band;
      this.setPull(this.E.pullSel, this.E.splitSel);
    },
    onHoverMed(e) {
      const s = e.target.closest ? e.target.closest('[data-medgrp]') : null;
      const v = s ? Number(s.dataset.medgrp) : null;
      if (v !== this.medEqGrp) this.medEqGrp = v;
    },
    // Событие внутри сессии выдвигает её карточку, событие между сессиями раздвигает пару.
    // fromPanel: клик пришёл из панели под сценой — взгляд внизу, к карточке надо ещё подняться
    selectEvent(id, fromPanel) {
      this.evSel = this.evSel === id ? null : id;
      let want = null, split = null;
      const e = this.evSel === null ? null : this.events.find(x => x.id === this.evSel);
      if (e) {
        if (e.at === 'in') want = this.rowIdx.has(e.sid) ? this.rowIdx.get(e.sid) : null;
        else if (e.gap) {
          const list = this.chrono;
          const a = list[e.gap[0]] ? this.rowIdx.get(list[e.gap[0]].id) : undefined;
          const b = list[e.gap[1]] ? this.rowIdx.get(list[e.gap[1]].id) : undefined;
          if (a !== undefined && b !== undefined && a !== b) split = [Math.min(a, b), Math.max(a, b)];
          else if (a !== undefined) want = a;
        }
      }
      // корешок выдвигать бессмысленно — сперва раскрываем его в карточку
      if (want !== null && this.spine) this.layerSel = want;
      this.$nextTick(() => {
        this.refresh();
        requestAnimationFrame(() => requestAnimationFrame(() => {
          this.setPull(want, split);
          this.flyToLayer(want !== null ? want : split ? split[0] : null, fromPanel);
        }));
      });
    },
    flyToLayer(k, page) {
      const it = k === null || k === undefined ? null : this.layout.items[k];
      if (!it) return;
      if (this.E.exploded && this.maxScroll >= 40) {
        // 300 px подлёта: карточка встаёт с парой соседей перед ней
        const t = Math.round(Math.max(0, Math.min(this.maxScroll, it.z + this.zOff - 300)));
        if (Math.abs(t - this.scrollZ) > 20) { this.scrollZ = t; this.applyScroll(); this.scheduleThin(); this.reframe(420); }
      }
      if (!page) return;
      requestAnimationFrame(() => {
        const st = this.$refs.stage;
        if (this.exiting || !st) return;
        const r = st.getBoundingClientRect();
        // сцена и так на виду больше чем наполовину — страницу не дёргаем
        const vis = Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
        if (r.height > 0 && vis / Math.min(r.height, window.innerHeight) > 0.5) return;
        st.scrollIntoView({ block: 'center', behavior: REDUCED ? 'auto' : 'smooth' });
      });
    },
    // Вход из клетки: ряд уже отсортирован по блоку оттока, подлетаем к началу группы
    // блока. Подлёт меряем в карточках: перед группой остаётся пара соседей.
    flyToBlock(b) {
      const items = this.layout.items;
      const k = this.units.findIndex(u => hitOf(u) === b);
      if (k < 0 || !items[k]) {
        // Оттока в этом блоке нет ни у одной сессии: проезжаем весь ряд и возвращаемся —
        // ответ самим движением, а не подмена соседним блоком.
        this.flyTo(this.maxScroll, 1600, () => setTimeout(() => { if (!this.exiting) this.flyTo(0, 1600); }, 520));
        return;
      }
      const nb = k >= 2 && items[k - 2] ? Math.abs(items[k].z - items[k - 2].z) : 40;
      this.flyTo(items[k].z + this.zOff - Math.max(24, Math.min(160, nb)), 1500);
    },
    // Перелёт к границе медианы: на реальных данных она бывает у дальнего края колоды.
    flyToMed() {
      if (this.medDepth === null || !this.E.exploded || this.maxScroll < 40) return;
      const t = Math.round(Math.max(0, Math.min(this.maxScroll, this.medDepth - 300)));
      if (Math.abs(t - this.scrollZ) < 20) return;
      this.scrollZ = t;
      this.applyScroll(); this.scheduleThin();
      this.reframe(420);
    },
    // Лента в режиме «прокрутка» (прототип tlScrollTo 6922): доля ленты → столбик → глубина
    // его карточки, между соседями линейно. При шаге по датам глубина неравномерна, и доля
    // глубины увозила бы сцену к чужой карточке.
    onScrollTo(frac) {
      // выбранная кликом карточка держала бы курсор, пока лента ведёт сцену
      if (this.layerSel !== 'all') { this.clearLayer(); this.applyLayer(); }
      const n = this.tlScene.length;
      if (!n) return;
      const f = Math.max(0, Math.min(n - 0.001, (Number(frac) || 0) * n));
      const i = Math.floor(f), k = f - i;
      const a = this.zForIdx(this.tlSceneIdx(i));
      const b = i + 1 < n ? this.zForIdx(this.tlSceneIdx(i + 1)) : a;
      this.scrollZ = Math.round(Math.max(0, Math.min(this.maxScroll, a + (b - a) * k)));
      if (!this.E.exploded) return;
      this.applyScroll(); this.scheduleThin();
    },
    onRange(r) {
      this.range = r && r.from != null && r.to != null ? { from: r.from, to: r.to } : null;
      // окно снято — весь ряд с первой карточки, как в П («1 из N»)
      if (!this.range) this.scrollZ = 0;
      // выбранный срез окно не снимает: карточка блока пересчитывается по окну (П 7066–7070);
      // выбранная карточка — снимает, после пересборки на её месте другая
      if (this.layerSel !== 'slice') this.clearLayer();
      this.rebuild();
    },
    // выход: слои складываются обратно в срез, камера возвращается в лоб, потом наружу
    exit() {
      if (this.exiting) return;
      this.exiting = true;
      this.sideView = false;
      this.collapse();
      this.arcTo({ x: 0, y: 0, z: 0, tx: 0, ty: 0, s: 1 }, REDUCED ? 0 : 820, { arc: 10, dolly: 60 },
        () => setTimeout(() => this.$emit('exit'), REDUCED ? 0 : 100));
    },
  },
};
</script>

<style scoped>
.ly-root { position: relative; padding-top: 4px; line-height: 1.4; }
.ly-stage { position: relative; width: 100%; perspective: 1500px; overflow-x: clip; overflow-y: visible;
  cursor: grab; user-select: none; touch-action: pan-y; }
.ly-stage:active { cursor: grabbing; }
.ly-cam { position: absolute; inset: 0; transform-style: preserve-3d; pointer-events: none; }
/* слои уезжают за пределы столбца, поэтому кликабельны только плитки — иначе прозрачные
   плоскости перехватывают клики */
.ly-l3 { position: absolute; inset: 0; transform-style: preserve-3d; pointer-events: none;
  transition: transform .95s cubic-bezier(.22,.8,.24,1), opacity .3s ease; }
.ly-track { position: absolute; inset: 0; transform-style: preserve-3d; }
.ly-cam.ly-noanim .ly-l3 { transition: none !important; will-change: opacity; }
.ly-cam.ly-noanim .ly-track { will-change: transform; }
.ly-cam.ly-noanim .ly-plate { box-shadow: 0 4px 10px var(--shadow-xs); }
.ly-l3 .ly-t { pointer-events: auto; }
.ly-l3.ly-dim .ly-t { pointer-events: none; }
.ly-l3.ly-half { opacity: .42; }
.ly-l3.ly-pull { z-index: 9; }
.ly-plate { position: absolute; background: var(--plate); border: 1px solid var(--border);
  border-radius: 12px; box-shadow: 0 10px 30px var(--shadow-xs); }
.ly-t { position: absolute; border-radius: 5px; display: flex; align-items: center; justify-content: center;
  font-size: 12px; font-variant-numeric: tabular-nums; cursor: pointer; transition: box-shadow .15s ease; }
.ly-t:hover { box-shadow: 0 0 0 2px var(--text-primary); }
.ly-t.ly-act { box-shadow: 0 0 0 2px var(--accent); }
.ly-t.ly-bin { background: transparent; box-shadow: inset 0 0 0 1px var(--border); font-weight: 600; }
.ly-t.ly-bin.ly-on { background: var(--accent); box-shadow: inset 0 0 0 1px var(--shadow-xs), 0 1px 4px var(--shadow-sm); }
.ly-t.ly-bin.ly-act { box-shadow: 0 0 0 2px var(--accent); }
/* при медиане синяя плитка красится по стороне границы */
.ly-md-lo .ly-t.ly-bin.ly-on { background: var(--cell-100); }
.ly-md-hi .ly-t.ly-bin.ly-on { background: var(--ev-goal); }
.ly-ring { position: absolute; border: 2px solid var(--accent); border-radius: 8px; opacity: .55; }
.ly-tag { position: absolute; font-size: 11px; font-weight: 650; letter-spacing: .02em; color: var(--text-muted);
  white-space: nowrap; max-width: 260px; overflow: hidden; text-overflow: ellipsis; }
.ly-slice .ly-tag { color: var(--accent); }
/* билборды: подписи всегда лицом к камере, иначе наклон делает их нечитаемыми */
.ly-tag, .ly-date, .ly-gap, .ly-cap, .ly-phcap { transform-origin: 0 50%; transform: rotateY(var(--by,0deg)) rotateX(var(--bx,0deg)); }
/* вдоль стопки карточка развёрнута целиком, второй поворот подписей сплющил бы текст */
.ly-face .ly-tag, .ly-face .ly-date, .ly-face .ly-gap, .ly-face .ly-cap, .ly-face .ly-phcap { transform: none; }
.ly-phd { display: inline-block; width: 7px; height: 7px; border-radius: 50%; margin-right: 5px; vertical-align: middle; }
.ly-rl { position: absolute; font-size: 12px; color: var(--text-secondary); display: flex; align-items: center;
  justify-content: flex-end; white-space: nowrap; padding-right: 12px; gap: 5px; border: 0; background: none;
  font-family: inherit; cursor: pointer; border-radius: 7px; pointer-events: auto;
  transition: transform .95s cubic-bezier(.22,.8,.24,1); }
.ly-rl span { overflow: hidden; text-overflow: ellipsis; }
.ly-rl i { font-style: normal; font-size: 11px; color: var(--text-muted); opacity: 0; transition: opacity .15s; }
.ly-rl:hover { color: var(--text-primary); background: var(--surface-1); }
.ly-rl:hover i { opacity: .75; }
.ly-rl.ly-sorted { color: var(--accent); font-weight: 650; }
.ly-rl.ly-sorted i { opacity: 1; color: var(--accent); font-weight: 700; }
.ly-rlhit span { border-bottom: 1px dashed currentColor; padding-bottom: 1px; }
.ly-phmix3 { position: absolute; display: flex; border-radius: 2px; overflow: hidden; box-shadow: 0 0 0 1px var(--surface-1); }
.ly-phmix3 i { display: block; height: 100%; }
.ly-phedge { position: absolute; height: 3px; border-radius: 2px; opacity: .95; }
.ly-phcap { position: absolute; font-size: 10px; font-weight: 700; letter-spacing: .02em; white-space: nowrap;
  background: var(--surface-1); border: 1px solid currentColor; border-radius: 999px; padding: 1px 8px; }
.ly-cdate { position: absolute; height: 13px; line-height: 13px; text-align: center; font-size: 9.5px;
  color: var(--text-muted); pointer-events: none; white-space: nowrap; overflow: hidden; }
.ly-date { position: absolute; font-size: 11px; color: var(--text-secondary); white-space: nowrap;
  background: var(--surface-1); border-radius: 4px; padding: 1px 5px; }
.ly-date b { color: var(--text-primary); font-weight: 650; }
.ly-date b.ly-acc { color: var(--accent); }
.ly-date i { font-style: normal; font-size: 9.5px; font-weight: 700; margin-left: 3px; padding: 0 4px;
  border-radius: 999px; background: var(--grid); color: var(--text-secondary); }
.ly-gap { position: absolute; font-size: 10px; font-weight: 650; white-space: nowrap; background: var(--surface-1);
  color: var(--accent); border: 1px solid var(--accent); border-radius: 999px; padding: 1px 7px; }
.ly-gap.ly-long { color: var(--cmp); border-color: var(--cmp); }
.ly-cap { position: absolute; white-space: nowrap; display: flex; flex-direction: column; justify-content: center; }
.ly-cap .ly-ct { font-size: 12.5px; font-weight: 650; color: var(--text-primary); line-height: 1.25; }
.ly-cap .ly-cs { font-size: 11px; color: var(--text-muted); font-variant-numeric: tabular-nums; line-height: 1.3; }
/* подпись выдвинутой карточки проявляется, когда та встала перед остальными */
.ly-cap.ly-pullcap { opacity: 0; transition: opacity .35s ease .28s; }
.ly-pull .ly-cap.ly-pullcap { opacity: 1; }
.ly-rail { position: absolute; transform-style: preserve-3d; pointer-events: none; transform-origin: 50% 0;
  background: linear-gradient(to bottom, var(--grid), transparent); }
.ly-rail i { position: absolute; left: -9px; width: 24px; height: 2px; background: var(--grid); border-radius: 1px; }
.ly-rail i.ly-big { left: -15px; width: 36px; height: 3px; background: var(--text-muted); opacity: .55; }
.ly-isl { position: absolute; transform-style: preserve-3d; pointer-events: none; background: var(--accent);
  border-radius: 3px; transform-origin: 50% 0; }
.ly-isllab { position: absolute; white-space: nowrap; font-size: 10.5px; font-weight: 650; color: var(--accent);
  background: var(--surface-1); border: 1px solid var(--accent); border-radius: 999px; padding: 1px 8px;
  pointer-events: none; transform-origin: 0 50%; }
.ly-grpcap { position: absolute; transform-origin: 0 50%; white-space: nowrap; display: inline-flex; align-items: center;
  gap: 7px; font-size: 12.5px; font-weight: 700; color: var(--c); letter-spacing: .01em; background: var(--surface-1);
  border: 1.5px solid var(--c); border-radius: 999px; padding: 3px 12px 3px 9px; box-shadow: 0 2px 10px var(--shadow-xs);
  max-width: 360px; overflow: hidden; text-overflow: ellipsis; }
.ly-grpcap b { width: 9px; height: 9px; border-radius: 50%; background: var(--c); flex: 0 0 auto; }
.ly-grpcap s { text-decoration: none; font-size: 11px; font-weight: 600; color: var(--text-muted); font-variant-numeric: tabular-nums; }
/* медиана */
.ly-med3d { position: absolute; width: 5px; border-radius: 3px; pointer-events: none; opacity: .92;
  background: repeating-linear-gradient(to bottom, var(--text-primary) 0 9px, var(--surface-1) 9px 16px);
  box-shadow: 0 0 0 1px var(--surface-1), 0 2px 10px var(--shadow-sm); }
.ly-medrow { position: absolute; height: 3px; border-radius: 2px; pointer-events: none; z-index: 2;
  background: repeating-linear-gradient(to right, var(--text-primary) 0 6px, transparent 6px 11px); }
.ly-medrib { position: absolute; width: 5px; border-radius: 3px; pointer-events: none; opacity: .8; transform-origin: 50% 0;
  background: repeating-linear-gradient(to bottom, var(--text-primary) 0 9px, var(--surface-1) 9px 16px);
  box-shadow: 0 0 0 1px var(--surface-1); }
/* граница «ровно на медиане» — через display: прозрачность сцена переписывает инлайном каждый кадр */
.ly-medeq { position: absolute; width: 4px; border-radius: 3px; pointer-events: none; display: none;
  background: repeating-linear-gradient(to bottom, var(--text-muted) 0 7px, var(--surface-1) 7px 13px); }
.ly-medeq.ly-on { display: block; }
.ly-medeqlab { position: absolute; white-space: nowrap; align-items: center; gap: 6px; transform-origin: 0 50%;
  background: var(--surface-1); border: 1px solid var(--text-muted); color: var(--text-secondary); border-radius: 999px;
  padding: 2px 10px 2px 7px; font-size: 11px; font-weight: 700; pointer-events: none; display: none;
  box-shadow: 0 2px 8px var(--shadow-xs); }
.ly-medeqlab.ly-on { display: inline-flex; }
.ly-medeqlab b { width: 8px; height: 8px; border-radius: 2px; background: var(--text-muted); }
.ly-medeqlab s { text-decoration: none; font-size: 10.5px; font-weight: 600; color: var(--text-muted); }
.ly-medpill { position: absolute; white-space: nowrap; font-size: 11px; font-weight: 650; color: var(--page);
  background: var(--text-primary); border-radius: 999px; padding: 3px 11px; transform-origin: 0 50%;
  pointer-events: auto; cursor: help; }
.ly-medseg { width: 7px; border-radius: 4px; opacity: .95; }
.ly-medlab { position: absolute; white-space: nowrap; display: inline-flex; align-items: center; gap: 6px;
  transform-origin: 0 50%; background: var(--surface-1); border: 1px solid var(--c); color: var(--c);
  border-radius: 999px; padding: 2px 10px 2px 7px; font-size: 11px; font-weight: 700; pointer-events: auto;
  cursor: pointer; box-shadow: 0 2px 8px var(--shadow-xs); }
.ly-medlab.ly-on { background: var(--c); color: var(--on-accent); box-shadow: 0 4px 14px var(--shadow-sm); }
.ly-medlab.ly-on b { background: var(--on-accent); }
.ly-medlab.ly-on s { color: var(--on-accent); opacity: .8; }
.ly-medlab b { width: 8px; height: 8px; border-radius: 2px; background: currentColor; }
.ly-medlab s { text-decoration: none; font-size: 10.5px; font-weight: 600; color: var(--text-muted); }
.ly-skarm { position: absolute; height: 8px; border-radius: 4px; transform-origin: 0 50%; pointer-events: auto;
  cursor: help; opacity: .95; box-shadow: 0 1px 4px var(--shadow-sm); }
.ly-skarm.ly-lo { background: var(--cell-100); }
.ly-skarm.ly-hi { background: var(--ev-goal); }
.ly-skpin { position: absolute; width: 21px; height: 21px; margin-left: -10.5px; margin-top: -10.5px; border-radius: 7px;
  background: var(--c); pointer-events: auto; cursor: help; transform-origin: 50% 50%;
  box-shadow: 0 2px 7px var(--shadow-sm), 0 0 0 2px var(--surface-1); }
.ly-sknum { position: absolute; white-space: nowrap; font-size: 10.5px; font-weight: 700; transform-origin: 50% 50%;
  pointer-events: auto; cursor: help; padding: 0 4px; border-radius: 6px; background: var(--surface-1);
  box-shadow: 0 1px 4px var(--shadow-xs); }
.ly-sknum.ly-lo { color: var(--cell-100); }
.ly-sknum.ly-hi { color: var(--ev-goal); }
/* словосочетания над сценой */
.ly-capnote { font-size: 12px; color: var(--text-secondary); background: var(--surface-1); border: 1px solid var(--border);
  border-radius: 8px; padding: 5px 10px; margin: 0 0 10px; }
.ly-phbar { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; margin: -8px 0 14px; }
.ly-plab { font-size: 12px; color: var(--text-muted); white-space: nowrap; margin-right: 2px; }
.ly-phchip { display: inline-flex; align-items: center; gap: 7px; border: 1px solid var(--border); background: var(--surface-1);
  border-radius: 999px; padding: 5px 12px; font-size: 12px; color: var(--text-secondary); white-space: nowrap; max-width: 420px; }
.ly-phchip b { color: var(--text-primary); font-weight: 650; overflow: hidden; text-overflow: ellipsis; }
.ly-phchip s, .ly-pr s, .ly-pr em { text-decoration: none; font-style: normal; color: var(--text-muted);
  font-variant-numeric: tabular-nums; white-space: nowrap; }
.ly-phchip i, .ly-pr i { width: 10px; height: 10px; border-radius: 50%; flex: 0 0 auto; display: block; }
.ly-phmix { display: flex; flex-direction: column; gap: 6px; width: 100%; max-width: 660px; }
.ly-phstack { display: flex; height: 12px; border-radius: 6px; overflow: hidden; border: 1px solid var(--border); background: var(--grid); }
.ly-phstack i { display: block; height: 100%; }
.ly-pr { display: grid; grid-template-columns: 10px minmax(0,1fr) auto auto; gap: 9px; align-items: center;
  font-size: 12px; color: var(--text-secondary); }
.ly-pr b { color: var(--text-primary); font-weight: 650; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
/* подсказка плиток сцены */
.ly-tip3 { position: absolute; z-index: 30; pointer-events: none; max-width: 320px; padding: 6px 10px;
  border-radius: 8px; background: var(--tooltip-bg); color: var(--tooltip-ink); font-size: 11.5px; line-height: 1.4;
  box-shadow: 0 6px 18px var(--shadow-sm); }
.ly-tip3 b { display: block; font-weight: 650; }
.ly-tip3 span { display: block; white-space: pre-line; opacity: .85; }
/* карточка сбоку */
.ly-detail { max-width: 660px; margin: 20px auto 0; width: 100%; }
.ly-dph { font-size: 12.5px; font-weight: 650; margin: -2px 0 4px; }
.ly-dsub { font-size: 12px; color: var(--text-secondary); margin: 4px 0 8px; }
.ly-path { display: flex; gap: 3px; margin: 8px 0 12px; }
.ly-pt { flex: 1 1 0; height: 22px; border-radius: 4px; font-size: 11px; display: flex; align-items: center;
  justify-content: center; cursor: pointer; color: var(--text-muted); box-shadow: inset 0 0 0 1px var(--border); }
.ly-pt.ly-reach { background: var(--accent-soft); color: var(--text-secondary); }
.ly-pt.ly-on { background: var(--accent); color: var(--on-accent); font-weight: 650; }
.ly-pt.ly-act { box-shadow: 0 0 0 2px var(--text-primary); }
.ly-shown { border-top: 1px dashed var(--border); padding-top: 8px; }
.ly-sh-h { font-size: 10.5px; letter-spacing: .04em; text-transform: uppercase; color: var(--text-muted); margin-bottom: 4px; }
.ly-sh-t { font-size: 15px; font-weight: 650; line-height: 1.25; }
.ly-sh-t.ly-none { color: var(--text-muted); font-weight: 400; }
.ly-sh-s { font-size: 12px; color: var(--text-secondary); margin-top: 3px; }
.ly-sh-src { font-size: 11px; color: var(--text-muted); margin-top: 6px; }
.ly-dbar { display: inline-block; height: 8px; border-radius: 4px; background: var(--accent); min-width: 3px; }
</style>
